import React from "react";
import {
  TabContent,
  TabPane,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Row,
  Col,
  CardFooter,
  Label,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from "reactstrap";
import Select from "react-select";

import axios from "axios";

import { PanelHeader, Button, ImageUpload, Stats, Timeline, CardDescription } from "components";

import { Redirect } from "react-router-dom";

import { theadcustomers, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { validateSpanishId } from "spain-id";
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor2 from '@ckeditor/ckeditor5-react';
import ClassicEditor2 from '@ckeditor/ckeditor5-build-classic';
import moment from "moment";
import "moment/locale/es";
import { duration } from "moment";

const PACK = 1;
const INTERNET = 2;
const MOVIL = 3;
const OTROS = 4;
const WIFI = 21;
const FIBRA = 22;

const CONTRATO = 228;
const PLANTILLA = 227;

// STEPS
const PRODUCTOS = 0;
const TIPO_CLIENTE = 1;
const DATOS_BASICOS = 2;
const DIRECCION = 3;
const FIRMA = 4;

const fiscalIdTypeOptions = [
  { value: "93", label: "DNI" },
  { value: "94", label: "NIE" },
  { value: "96", label: "Pasaporte" } /*,
  { value: "95", label: "NIF" }
  ,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
const customerTypeOptions = [
  { value: "89", label: "Particular" },
  { value: "91", label: "Autónomo" },
  { value: "90", label: "Empresa" },
  { value: "92", label: "Extranjero" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
var localityStyle = {
  padding: "5px 10px",
  background: "rgba(255,255,255,0.1)",
  borderRadius: "2px",
  margin: "0px 10px 0px 5px"
};
const NEW_PHOTO = "new-photo";
const CUSTOMER_SIGNATURE = "customer-signature";
const TECHNICIAN_SIGNATURE = "technician-signature";
const FINISH_HOME_VISIT = "finish-home-visit";
const FINISHED_HOME_VISIT = "finished-home-visit";

//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});


const emojis = {
  angry: {
    icon: "🤬",
    value: 255,
    text: "Enfadado"
  },
  unhappy: {
    icon: "😐",
    value: 254,
    text: "Descontento"
  },
  normal: {
    icon: "🙂",
    value: 253,
    text: "Normal"
  },
  happy: {
    icon: "😄",
    value: 252,
    text: "Contento"
  },
  inlove: {
    icon: "😍",
    value: 251,
    text: "Muy contento"
  }
};

class ViewReminder extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      reminderId: parseInt(this.props.match.params.reminderId),
      reminder: null,
      areItemsLoading: false,
      contractProducts: null /*this.props.state.contract.products*/,
      templateName: null,
      fieldStates: [],
      productsLoaded: false,
      signature: null /*this.props.state.contract.signature*/,
      signatureTechnician: null,
      currentStep: PRODUCTOS,
      customerData: null /*this.props.state.contract.customer*/,
      identificationDocuments: /*this.props.state.contract.documents ||*/ {},
      contractLoaded: false,
      isSigningContract: false,
      showNewCommentBox: false,
      commentText: "",
      commentTextTechnician: "",
      showPhotos: false,
      showComments: false,
      isFinishingHomeVisit: false,
      customerSignature: null,
      customerHappiness: null
    };
    this.buildProductsCards = this.buildProductsCards.bind(this);
    this.buildContractProducts = this.buildContractProducts.bind(this);
    this.addProductToContract = this.addProductToContract.bind(this);
    this.cleanContractProducts = this.cleanContractProducts.bind(this);
    // this.validateField = this.validateField.bind(this);
    this.validateSendContract = this.validateSendContract.bind(this);
    this.sendContract = this.sendContract.bind(this);
    this.saveTemplate = this.saveTemplate.bind(this);
    this.createContract = this.createContract.bind(this);
    this.saveSignature = this.saveSignature.bind(this);
    this.buildFooter = this.buildFooter.bind(this);
    this.nextClick = this.nextClick.bind(this);
    this.previousClick = this.previousClick.bind(this);
    this.buildCustomerType = this.buildCustomerType.bind(this);
    this.buildCustomerBasicData = this.buildCustomerBasicData.bind(this);
    this.buildCustomerAddress = this.buildCustomerAddress.bind(this);
    this.buildSignature = this.buildSignature.bind(this);
    this.checkCustomerType = this.checkCustomerType.bind(this);
    this.checkBasicData = this.checkBasicData.bind(this);
    this.checkBasicDataNotCompany = this.checkBasicDataNotCompany.bind(this);
    this.checkAddress = this.checkAddress.bind(this);
    this.clearSignature = this.clearSignature.bind(this);
    this.buildExistingCustomer = this.buildExistingCustomer.bind(this);

    this.buildComments = this.buildComments.bind(this);
    this.addComment = this.addComment.bind(this);
    this.addPhoto = this.addPhoto.bind(this);
    this.buildPhotos = this.buildPhotos.bind(this);
    this.setUploadedPhoto = this.setUploadedPhoto.bind(this);
    this.cancelAddComment = this.cancelAddComment.bind(this);
    this.cancelAddPhoto = this.cancelAddPhoto.bind(this);
    this.activateEditPhoto = this.activateEditPhoto.bind(this);
    this.editPhotoText = this.editPhotoText.bind(this);
    this.activateDeletePhoto = this.activateDeletePhoto.bind(this);
    this.deactivateDeletePhoto = this.deactivateDeletePhoto.bind(this);
    this.isTechnicianWorking = this.isTechnicianWorking.bind(this);
    this.exitHomeVisit = this.exitHomeVisit.bind(this);
    this.startHomeVisit = this.startHomeVisit.bind(this);
    this.changeBillingStatus = this.changeBillingStatus.bind(this);
    this.buildHomeVisitHeaderStatus = this.buildHomeVisitHeaderStatus.bind(this);
    this.finishHomeVisitProccess = this.finishHomeVisitProccess.bind(this);
    // this.buildContent = this.buildContent.bind(this);
    // this.buildHomeVisitBody = this.buildHomeVisitBody.bind(this);
    this.changeHappiness = this.changeHappiness.bind(this);
    this.checkCustomerSignature = this.checkCustomerSignature.bind(this);
    this.checkTechnicianSignature = this.checkTechnicianSignature.bind(this);
    this.deleteHomeVisit = this.deleteHomeVisit.bind(this);
    this.cancelDeleteHomeVisit = this.cancelDeleteHomeVisit.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.editHomeVisit = this.editHomeVisit.bind(this);
    this.buildRelatedContract = this.buildRelatedContract.bind(this);

    this.redirectTo = this.redirectTo.bind(this);
    this.loadReminder = this.loadReminder.bind(this);
    this.buildMainContent = this.buildMainContent.bind(this);
    this.buildRightColumn = this.buildRightColumn.bind(this);
    /* ////console.log(props); */

    // this.props.userData.getHomeVisitTypesList();
    // this.props.userData.getHomeVisitFinishReasonList();
  }
  componentDidMount() {
    this.loadReminder();
  }
  async loadReminder() {
    let reminderId = this.state.reminderId;
    if (!reminderId) return;
    this.setState({ loadingReminder: true });
    this.props.userData.loadReminder(reminderId).then(result => {
      this.setState({ loadingReminder: false });
      if (result.ok) {
        this.setState({
          reminder: result.reminder,
        });
      } else {
        console.log("Something went wrong loading reminder: " + result.error);
      }
    })
    .catch((error) => {
      this.setState({ loadingReminder: false });
      // Error 😨
      console.log("Something went wrong loading reminder: " + error.message);
      // console.log("Error al obtener los impuestos y los conceptos: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.state.homeVisit && this.props.mainState.homeVisits && this.props.mainState.homeVisits.byId && (this.state.homeVisitId in this.props.mainState.homeVisits.byId)) {
      let homeVisit = this.props.mainState.homeVisits.byId[this.state.homeVisitId][0];
      if (homeVisit && homeVisit.visit_type)
        this.setState({ homeVisit: homeVisit });
    }
    if (!this.props.mainState.isCreatingHomeVisitComment && prevProps.mainState.isCreatingHomeVisitComment) {
      let homeVisit = this.props.mainState.homeVisits.byId[this.state.homeVisitId];
      this.setState({ homeVisit: homeVisit });
    }
    if (!this.props.mainState.isCreatingHomeVisitPhoto && prevProps.mainState.isCreatingHomeVisitPhoto) {
      let homeVisit = this.props.mainState.homeVisits.byId[this.state.homeVisitId];
      this.setState({ homeVisit: homeVisit });
    }
    if (!this.props.mainState.isEditingHomeVisitPhoto && prevProps.mainState.isEditingHomeVisitPhoto) {
      let homeVisit = this.props.mainState.homeVisits.byId[this.state.homeVisitId];
      this.setState({ homeVisit: homeVisit });
    }
    if (!this.props.mainState.isDeletingHomeVisitPhoto && prevProps.mainState.isDeletingHomeVisitPhoto) {
      let homeVisit = this.props.mainState.homeVisits.byId[this.state.homeVisitId];
      this.setState({ homeVisit: homeVisit });
    }
    if (!this.props.mainState.isStartingHomeVisit && prevProps.mainState.isStartingHomeVisit) {
      let homeVisit = this.props.mainState.homeVisits.byId[this.state.homeVisitId];
      this.setState({ homeVisit: homeVisit });
    }
    if (!this.props.mainState.isChangingHomeVisitBillingStatus && prevProps.mainState.isChangingHomeVisitBillingStatus) {
      let homeVisit = this.props.mainState.homeVisits.byId[this.state.homeVisitId];
      this.setState({ homeVisit: homeVisit });
    }
    if (!this.props.mainState.isFinishingHomeVisit && prevProps.mainState.isFinishingHomeVisit) {
      let homeVisit = this.props.mainState.homeVisits.byId[this.state.homeVisitId];
      this.setState({
        homeVisit: homeVisit,
        finishingStep: FINISHED_HOME_VISIT,
        finishText: parseInt(homeVisit.visit_state.tid) !== 249 ? "Error al firmar" : "Firmado"
      });
    }
    if (this.state.homeVisit && this.state.homeVisit.visit_state && parseInt(this.state.homeVisit.visit_state.tid) === 248) {
      this.interval = setInterval(() => this.setState({ time: Date.now() }), 60000);
    }
    // console.log("######## UPDATE VIEW HOME VISIT - mainState ######");
    // console.log(this.props.mainState);
    // console.log("######## UPDATE VIEW HOME VISIT - state ######");
    // console.log(this.state);
    // console.log("Actualizando componente");
    // console.log("state");
    // console.log(this.state);
    // console.log("prevState");
    // console.log(prevState);
    if (this.state.finishingStep && this.state.finishingStep !== prevState.finishingStep && this.signature) {
      console.log("Rellenando firma después de actualizar");
      switch (this.state.finishingStep) {
        case CUSTOMER_SIGNATURE:
          this.signature.clear();
          if (this.state.signature) this.signature.fromDataURL(this.state.signature);
          break;
        case TECHNICIAN_SIGNATURE:
          this.signature.clear();
          if (this.state.signatureTechnician) this.signature.fromDataURL(this.state.signatureTechnician);
          break;
        default:
          this.signature.clear();
      }
    }
  }
  saveSignature() {
    if (this.state.finishingStep === CUSTOMER_SIGNATURE) {
      this.setState({ signature: this.signature.toDataURL() });
    } else {
      this.setState({ signatureTechnician: this.signature.toDataURL() });
    }
  }
  validateSendContract() {
    let result = true;
    this.state.contractProducts.map(product => {
      product.extraFields.map(field => {
        if (this.state.fieldStates[field.id] === "has-danger") result = false;
        if (!this.state.fieldStates[field.id]) result = false;
      });
    });
    if (this.state.fieldStates['clientMobile'] === "has-danger") result = false;
    if (!this.state.fieldStates['clientMobile']) result = false;
    if (this.state.fieldStates['contractIdentifier'] === "has-danger") result = false;
    if (!this.state.fieldStates['contractIdentifier']) result = false;
    return result;
  }
  validateSaveTemplate() {
    let result = true;
    if (this.state.fieldStates['nombrePlantilla'] === "has-danger") result = false;
    if (!this.state.fieldStates['nombrePlantilla']) result = false;
    return result;
  }
  cleanContractProducts() {
    this.setState({ contractProducts: null });
  }
  removeProductToContract(id) {
    let auxContractProducts = this.state.contractProducts;
    auxContractProducts = auxContractProducts.map((product, key) => {
      if (key !== id) return product;
      return null;
    });
    auxContractProducts = auxContractProducts.filter(function(el) {
      return el != null;
    });
    this.setState({
      contractProducts: auxContractProducts
    });
  }
  addProductToContract(product) {
    // console.log("###### addProduct ######");
    // console.log(this.state.contractProducts);
    product.id = Date.now() + "product" + product.id + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    product.extraFields = [];

    switch (product.type) {
      case INTERNET:
        product.extraFields.push({
          id: product.id + "field1" + "-text",
          label: "Dirección",
          placeholder: "Calle Melan...",
          type: "text",
          value: ""
        });
        break;
      case MOVIL:
        product.extraFields.push({
          id: product.id + "field1" + "-mobile",
          label: "Móvil",
          placeholder: "612345678",
          type: "number",
          value: ""
        });
        break;
      case PACK:
        product.extraFields.push({
          id: product.id + "field1" + "-text",
          label: "Dirección",
          placeholder: "Calle Melan...",
          type: "text",
          value: ""
        });
        product.extraFields.push({
          id: product.id + "field2" + "-mobile",
          label: "Móvil",
          placeholder: "612345678",
          type: "number",
          value: ""
        });
        break;
      default:
        break;
    }

    let auxContractProducts = this.state.contractProducts;
    if (!auxContractProducts) auxContractProducts = [];
    auxContractProducts.push(JSON.parse(JSON.stringify(product)));
    // console.log("###### addProduct - auxContractProducts ######");
    // console.log(auxContractProducts);
    this.setState({
      contractProducts: auxContractProducts
    });
  }
  buildContractProducts() {
    // console.log("######### PRODUCTOS CONTRATO ########");
    // console.log(JSON.stringify(this.state.contractProducts));
    let contractContent = null;
    let classifiedContractContent = null;
    if (this.state.contractProducts && this.state.contractProducts.length > 0) {
      contractContent = [];
      classifiedContractContent = [];
      let total = 0;
      let cardsProps = {
        xs: 12,
        lg: 6
      };

      this.state.contractProducts.map((product, key) => {
        let productColor = "default";
        let productType = "General";
        let subTotal = product.price.replace(" €", "").replace(",", ".");
        let textColor = ""
        let currentTypeName = "";
        if (!product.label.toLowerCase().includes("instalaci")) {
          subTotal = parseFloat(subTotal);
          total += subTotal;
        }
        switch (product.type) {
          case INTERNET:
            productType = "Fibra";
            productColor = "warning";
            currentTypeName = "Internet";
            if (product.subtype === WIFI) {
              productColor = "primary";
              productType = "WiFi";
            }
            break;
          case PACK:
            productType = "Pack";
            productColor = "info";
            textColor = "text-white";
            currentTypeName = "Packs";
            break;
          case OTROS:
            productType = "Otros";
            productColor = "danger";
            currentTypeName = "Otros";
            break;
          case MOVIL:
            productType = "Móvil";
            productColor = "default";
            currentTypeName = "Móvil";
            if (product.provider) {
              if (product.provider.id === "163") productColor = "blue";
              if (product.provider.id === "164") productColor = "orange";
            }
            break;
          default:
            break;
        }
        let productFields = [];
        // console.log("##### current product #####");
        // console.log(this.state.contractProducts[key]);
        productFields = product.extraFields.map((field, fieldKey) => {
          // console.log("##### current product - field #####");
          // console.log(this.state.contractProducts[key].extraFields[fieldKey]);
          return (
            <FormGroup
              key={field.id}
              className={this.state.fieldStates[field.id]}
            >
              <Input
                disabled
                className="text-center"
                type={field.type}
                placeholder={field.placeholder}
                style={{ backgroundColor: "white" }}
                value={this.state.contractProducts[key].extraFields[fieldKey].value || ""}
                onChange={event => {
                  let newValue = event.target.value;
                  if (field.type === "number") newValue = newValue.replace(/\s+/g, '');
                  let newContractProducts = this.state.contractProducts;
                  newContractProducts[key].extraFields[fieldKey].value = newValue;

                  this.setState({ contractProducts: newContractProducts });
                  // this.validateField("phoneNumber", event.target.value.replace(/\s+/g, ''));
                  this.validateField(field.id, newValue);
                }}
              />
            </FormGroup>
          );
        });
        let currentClassifiedContractContent = [];
        if (product.type in classifiedContractContent) currentClassifiedContractContent = classifiedContractContent[product.type].products;
        currentClassifiedContractContent.push(
          <Col key={key} {...cardsProps}>
            <Card
              color={productColor}
              className={"text-center " + textColor}
              onContextMenu={e => {
                e.preventDefault();
                this.removeProductToContract(key);
              }}
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardBody>{productFields}</CardBody>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">{productType}</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
        classifiedContractContent[product.type] = {
          name: currentTypeName,
          products: currentClassifiedContractContent
        };
      });
      contractContent = [];
      classifiedContractContent.map((currentType, key) => {
        let temporaryProductsToWrap = [];
        temporaryProductsToWrap.push(
          <Col key={currentType.name} xs={12}>
            <h5>{currentType.name}</h5>
          </Col>
        );
        currentType.products.map(currentProduct => {
          temporaryProductsToWrap.push(currentProduct);
        });
        contractContent.push(<Row key={key + currentType.name}>{temporaryProductsToWrap}</Row>);
      });

      let contractHeader =
        <Card className="text-center" color="info">
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Mensualidad</CardTitle>
          </CardHeader>
          <CardBody className="text-center txt-white h3 h-nomargin">
            {(total.toFixed(2) + " €").replace(".", "'")}
          </CardBody>
          <CardFooter></CardFooter>
        </Card>;

      contractContent = 
        <div>
          {contractHeader}
          <Card>
            <CardHeader>
              <CardTitle tag="h4" className="text-center">Servicios del contrato</CardTitle>
            </CardHeader>
            <CardBody>
              {contractContent}
            </CardBody>
          </Card>
        </div>;
    } else {
      contractContent = 
        <Card>
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Servicios del contrato</CardTitle>
          </CardHeader>
          <CardBody>
            <div className="text-center">
              <i className="now-ui-icons shopping_box" /> ¡Añade servicios pulsando sobre ellos!
            </div>
            <br />
          </CardBody>
        </Card>;
    }
    return contractContent;
  }
  buildProductsCards(internetProducts, packProducts, othersProducts, mobileProducts) {
    let result = null;
    let resultFibra = [];
    let resultWifi = [];
    let resultPacks = [];
    let resultOthers = [];
    let resultMobiles = [];
    let fibraNumber = 0;
    let wifiNumber = 0;
    let cardsProps = {
      xs: 12 /*,
      xl: 6*/
    }
    if (internetProducts) {
      internetProducts.map(product => {
        let currentType = resultFibra;
        if (product.subtype === FIBRA) {
          fibraNumber += 1;
        } else {
          wifiNumber += 1;
          currentType = resultWifi;
        }
        currentType.push(
          <Col key={"internetProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color={product.subtype === FIBRA ? "warning" : "primary"}
              className="text-center"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">{product.subtype === FIBRA ? "Fibra" : "WiFi"}</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
        if (product.subtype === FIBRA) {
          resultFibra = currentType;
        } else {
          resultWifi = currentType;
        }
      });
    }
    if (packProducts) {
      packProducts.map(product => {
        resultPacks.push(
          <Col key={"packProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color="info"
              className="text-center text-white"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">Pack</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
      });
    }
    if (othersProducts) {
      othersProducts.map(product => {
        resultOthers.push(
          <Col key={"othersProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color="danger"
              className="text-center"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">Otros</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
      });
    }
    if (mobileProducts) {
      mobileProducts.map(product => {
        let productColor = "default";
        if (product.provider) {
          if (product.provider.id === "163") productColor = "blue";
          if (product.provider.id === "164") productColor = "orange";
        }
        resultMobiles.push(
          <Col key={"mobilesProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color={productColor}
              className="text-center"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">Móvil</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
      });
    }

    result = 
      <TabContent activeTab={this.state.vTabs}>
        <TabPane tabId="vt1">
          <Nav pills className="nav-pills-primary">
            <NavItem>
              <NavLink
                className={
                  this.state.internetTabs === "fibra" ? "active" : ""
                }
                onClick={() => this.setState({ internetTabs: "fibra" })}
              >
                {"Fibra (" + fibraNumber + ")"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  this.state.internetTabs === "wifi" ? "active" : ""
                }
                onClick={() => this.setState({ internetTabs: "wifi" })}
              >
              {"WiFi (" + wifiNumber + ")"}
              </NavLink>
            </NavItem>
          </Nav>
          <br />
          <TabContent activeTab={this.state.internetTabs}>
            <TabPane tabId="fibra">
              <Row>
                {resultFibra}
              </Row>
            </TabPane>
            <TabPane tabId="wifi">
              <Row>
                {resultWifi}
              </Row>
            </TabPane>
          </TabContent>
        </TabPane>
        <TabPane tabId="vt2">
          <Row>
            {resultPacks}
          </Row>
        </TabPane>
        <TabPane tabId="vt4">
          <Row>
            {resultMobiles}
          </Row>
        </TabPane>
        <TabPane tabId="vt3">
          <Row>
            {resultOthers}
          </Row>
        </TabPane>
      </TabContent>;
    
    return result;
  }
  sendContract() {
    if (this.validateSendContract()) {
      let contract = {
        name: this.state.contractIdentifier,
        products: JSON.stringify(this.state.contractProducts),
        mobile: this.state.clientMobile,
        type: CONTRATO
      };
      this.createContract(contract);
    }
  }
  saveTemplate() {
    if (this.validateSaveTemplate()) {
      let contract = {
        name: this.state.templateName,
        products: JSON.stringify(this.state.contractProducts),
        type: PLANTILLA
      };
      this.createContract(contract);
    }
  }
  createContract(contract) {
    this.props.createContract(contract);
  }
  checkCustomerType() {
    let result = true;
    if (!this.state.customerData.customerType) {
      result = false;
    }

    return result;
  }
  checkBasicData() {
    if (this.state.customerData.customerType.value === "90") {
      return this.checkBasicDataCompany();
    } else {
      return this.checkBasicDataNotCompany();
    }
  }
  checkBasicDataNotCompany() {
    let result = true;
    if (!this.state.customerData.fiscalIdType) {
      result = false;
      let options = {
        place: "tr",
        message: "Es necesario especificar el tipo de documento identificativo",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.dni || (this.state.fieldStates['dni'] && this.state.fieldStates['dni'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El " + (this.state.customerData.fiscalIdType ? this.state.customerData.fiscalIdType.label : "documento identificativo") + " es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.firstname || (this.state.fieldStates['firstname'] && this.state.fieldStates['firstname'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El nombre es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.lastname || (this.state.fieldStates['lastname'] && this.state.fieldStates['lastname'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El primer apellido es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.lastname2 || (this.state.fieldStates['lastname2'] && this.state.fieldStates['lastname2'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El segundo apellido es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.mobile || (this.state.fieldStates['mobile'] && this.state.fieldStates['mobile'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El móvil es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.email || (this.state.fieldStates['email'] && this.state.fieldStates['email'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El email es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.iban || (this.state.fieldStates['iban'] && this.state.fieldStates['iban'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El IBAN es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }

    return result;
  }
  checkBasicDataCompany() {
    let result = true;
    if (!this.state.customerData.dni || (this.state.fieldStates['dni'] && this.state.fieldStates['dni'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El " + (this.state.customerData.fiscalIdType ? this.state.customerData.fiscalIdType.label : "documento identificativo") + " es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.firstname || (this.state.fieldStates['firstname'] && this.state.fieldStates['firstname'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El nombre es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.mobile || (this.state.fieldStates['mobile'] && this.state.fieldStates['mobile'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El móvil es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.email || (this.state.fieldStates['email'] && this.state.fieldStates['email'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El email es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.iban || (this.state.fieldStates['iban'] && this.state.fieldStates['iban'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El IBAN es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.firstnameManager || (this.state.fieldStates['firstnameManager'] && this.state.fieldStates['firstnameManager'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El nombre del gerente es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.lastnameManager || (this.state.fieldStates['lastnameManager'] && this.state.fieldStates['lastnameManager'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El primer apellido del gerente es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.lastname2Manager || (this.state.fieldStates['lastname2Manager'] && this.state.fieldStates['lastname2Manager'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El segundo apellido del gerente es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.dniManager || (this.state.fieldStates['dniManager'] && this.state.fieldStates['dniManager'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El DNI del gerente es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }

    return result;
  }
  checkAddress() {
    let result = true;
    if (!this.state.customerData.street || (this.state.fieldStates['street'] && this.state.fieldStates['street'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "La calle es incorrecta",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.locality || (this.state.fieldStates['locality'] && this.state.fieldStates['locality'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "La localidad es incorrecta",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.postalCode || (this.state.fieldStates['postalCode'] && this.state.fieldStates['postalCode'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El código postal es incorrecto",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.province || (this.state.fieldStates['province'] && this.state.fieldStates['province'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "La provincia es incorrecta",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.comunity || (this.state.fieldStates['comunity'] && this.state.fieldStates['comunity'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "La comunidad es incorrecta",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }

    return result;
  }
  checkSignature() {
    let result = true;
    if (!this.signature || this.signature.isEmpty()) {
      result = false;
      let options = {
        place: "tr",
        message: "Es necesario rellenar la firma del cliente",
        type: "danger",
        icon: "now-ui-icons design-2_ruler-pencil",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.signatureTechnician || this.signatureTechnician.isEmpty()) {
      result = false;
      let options = {
        place: "tr",
        message: "Es necesario rellenar la firma del técnico",
        type: "danger",
        icon: "now-ui-icons design-2_ruler-pencil",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.identificationDocuments) {
      result = false;
      let options = {
        place: "tr",
        message: "Son necesarias las fotos del documento de identidad",
        type: "danger",
        icon: "now-ui-icons design_image",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    } else {
      if (!this.state.identificationDocuments.front) {
        result = false;
        let options = {
          place: "tr",
          message: "Es necesaria la foto frontal del documento de identidad",
          type: "danger",
          icon: "now-ui-icons design_image",
          autoDismiss: 3
        };
        this.props.showNotification(options);
      }
      if (!this.state.identificationDocuments.back) {
        result = false;
        let options = {
          place: "tr",
          message: "Es necesaria la foto trasera del documento de identidad",
          type: "danger",
          icon: "now-ui-icons design_image",
          autoDismiss: 3
        };
        this.props.showNotification(options);
      }
    }
    return result;
  }
  checkContract() {
    return (
      this.checkCustomerType() &&
      this.checkBasicData() &&
      this.checkAddress() &&
      this.checkSignature()
    );
  }
  nextClick() {
    switch (this.state.currentStep) {
      case PRODUCTOS:
        if (this.state.existingCustomer) {
          this.setState({ currentStep: FIRMA });
        } else {
          this.setState({ currentStep: TIPO_CLIENTE });
        }
        break;
      case TIPO_CLIENTE:
        if (this.checkCustomerType()) {
          let aux = this.state;
          if (this.state.customerData.customerType.value === "90") {
            aux.customerData.fiscalIdType = { value: "95", label: "NIF" };
          } else {
            if (this.state.customerData.fiscalIdType && this.state.customerData.fiscalIdType.value === "95")
              aux.customerData.fiscalIdType = undefined;
          }
          this.setState({ currentStep: DATOS_BASICOS });
        } else {
          var options = {
            place: "tr",
            message: "Es necesario especificar el tipo de cliente",
            type: "danger",
            icon: "now-ui-icons users_single-02",
            autoDismiss: 3
          };
          this.props.showNotification(options);
        }
        break;
      case DATOS_BASICOS:
        if (this.checkBasicData()) {
          this.setState({ currentStep: DIRECCION });
        }
        break;
      case DIRECCION:
        if (this.checkAddress()) {
          this.setState({ currentStep: FIRMA });
        }
        break;
      default:
    }
  }
  previousClick() {
    switch (this.state.currentStep) {
      case FIRMA:
        if (this.state.existingCustomer) {
          this.setState({ currentStep: PRODUCTOS });
        } else {
          this.setState({ currentStep: DIRECCION });
        }
        break;
      case DIRECCION:
        this.setState({ currentStep: DATOS_BASICOS });
        break;
      case DATOS_BASICOS:
        this.setState({ currentStep: TIPO_CLIENTE });
        break;
      case TIPO_CLIENTE:
        this.setState({ currentStep: PRODUCTOS });
        break;
      default:
    }
  }
  exitClick() {
    let saveContract = Object.keys(this.state.customerData).length > 0;
    let contract = null;
    if (saveContract)
      contract = {
        customer: JSON.stringify(this.state.customerData),
        documents: this.state.identificationDocuments
      };
    this.props.closeContract(contract);
    this.setState({
        goToContracts: true
    });
  }
  signContract() {
    if (this.checkContract()) {
      let contract = null;
      contract = {
        customer: JSON.stringify(this.state.customerData),
        documents: this.state.identificationDocuments,
        signature: this.signature.toDataURL()
      };
      this.props.closeContract(contract);
    }
  }
  isTechnicianWorking() {
    let result = false;
    if (this.state.homeVisit.working_technician && this.state.homeVisit.working_technician.length > 0) {
      const groupByID = groupBy('id');
      const groupedElements = groupByID(this.state.homeVisit.working_technician);
      result = this.props.mainState.user.uid in groupedElements;
    }
    return result;
  }
  exitHomeVisit() {
    this.setState({ redirect: "/citas" });
  }
  startHomeVisit() {
    this.props.userData.startHomeVisit(this.state.homeVisit.id);
  }
  deleteHomeVisit() {
    if (this.state.confirmingDelete) {
      this.props.userData.deleteHomeVisit(this.state.homeVisit.id);
      this.exitHomeVisit();
    } else {
      this.setState({ confirmingDelete: true });
    }
  }
  editHomeVisit() {
    this.redirectTo("/citas/editar/" + this.state.homeVisitId);
  }
  cancelDeleteHomeVisit() {
    this.setState({ confirmingDelete: false });
  }
  checkCustomerSignature() {
    let result = true;
    if (!this.state.signature) {
      result = false;
      let options = {
        place: "tr",
        message: "Es necesario firmar",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.userData.showNotification(options);
    }
    if (!this.state.happiness) {
      result = false;
      let options = {
        place: "tr",
        message: "Es necesario especificar qué te ha parecido pulsando sobre uno de los iconos 😊",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.userData.showNotification(options);
    }
    return result;
  }
  checkTechnicianSignature() {
    let result = true;
    if (!this.state.signatureTechnician) {
      result = false;
      let options = {
        place: "tr",
        message: "Es necesario firmar",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.userData.showNotification(options);
    }
    if (!this.state.finishReason) {
      result = false;
      let options = {
        place: "tr",
        message: "Es necesario especificar el motivo",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.userData.showNotification(options);
    }
    if (this.state.finishReason && this.state.finishReason.value !== 257) {
      if (!this.state.commentTextTechnician) {
        result = false;
        let options = {
          place: "tr",
          message: "Es necesario explicar porqué no está todo correcto",
          type: "danger",
          icon: "now-ui-icons users_single-02",
          autoDismiss: 3
        };
        this.props.userData.showNotification(options);
      }
      if (this.state.commentTextTechnician && (this.state.commentTextTechnician === "" || this.state.commentTextTechnician.length === 0)) {
        result = false;
        let options = {
          place: "tr",
          message: "Es necesario explicar porqué no está todo correcto",
          type: "danger",
          icon: "now-ui-icons users_single-02",
          autoDismiss: 3
        };
        this.props.userData.showNotification(options);
      }
    }
    return result;
  }
  finishHomeVisitProccess(step) {
    switch (step) {
      case TECHNICIAN_SIGNATURE:
        this.setState({ 
          isFinishingHomeVisit: true,
          finishingStep: TECHNICIAN_SIGNATURE
        });
        break;
      case CUSTOMER_SIGNATURE:
        if (this.checkTechnicianSignature()) {
          this.setState({
            finishingStep: CUSTOMER_SIGNATURE
          });
        }
        break;
      case FINISH_HOME_VISIT:
        if (this.checkCustomerSignature()) {
          this.setState({
            finishingStep: FINISH_HOME_VISIT
          });
          let finishData = {
            home_visit_id: parseInt(this.state.homeVisit.id),
            customer_signature: this.state.signature,
            customer_opinion: this.state.happiness.value,
            customer_comment: this.state.commentText ? this.state.commentText.toString() : "",
            finish_reason: this.state.finishReason.value,
            technician_signature: this.state.signatureTechnician,
            issue_description: this.state.commentTextTechnician ? this.state.commentTextTechnician.toString() : ""
          };
          console.log("######## FINISHING HOME VISIT - finishData #########");
          console.log(finishData);
          this.props.userData.finishHomeVisit(finishData);
        }
        // this.props.userData.finishHomeVisit(this.state.homeVisit.id);
        break;
      default:
        break;
    }
  }
  buildFooter() {
    if (this.state.finishingStep === FINISH_HOME_VISIT) return null;
    let leftButton = null;
    let rightButton = null;
    let bottomButton = null;
    let deleteButton = null;
    let editButton = null;

    let isWorking = this.isTechnicianWorking();

    if (this.state.homeVisit && this.state.homeVisit.visit_state) {
      deleteButton = {
        text: "Eliminar",
        color: "danger",
        callback: this.deleteHomeVisit
      };
      editButton = {
        text: "Editar",
        color: "info",
        callback: this.editHomeVisit
      };
      switch (this.state.homeVisit.visit_state.tid) {
        // Cancelada
        case 250:
          leftButton = {
            text: "Salir",
            color: "default",
            callback: this.exitHomeVisit
          };
          break;
          // Esperando
        case 247:
          leftButton = {
            text: this.props.mainState.isStartingHomeVisit ? <div><i className="now-ui-icons arrows-1_refresh-69 spin" /> Empezando </div> : "Empezar",
            color: "primary",
            disabled: this.props.mainState.isStartingHomeVisit,
            callback: this.startHomeVisit
          };
          rightButton = {
            text: "Salir",
            color: "default",
            callback: this.exitHomeVisit
          };
          break;
          // En proceso
        case 248:
          if (this.isTechnicianWorking()) {
            if (this.state.isFinishingHomeVisit) {
              switch (this.state.finishingStep) {
                case TECHNICIAN_SIGNATURE:
                  leftButton = {
                    text: "Firmar",
                    color: "primary",
                    callback: () => this.finishHomeVisitProccess(CUSTOMER_SIGNATURE)
                  };
                  break;
                case CUSTOMER_SIGNATURE:
                  leftButton = {
                    text: "Firmar",
                    color: "primary",
                    callback: () => this.finishHomeVisitProccess(FINISH_HOME_VISIT)
                  };
                  break;
                default:
                  leftButton = {
                    text: "Firmar",
                    color: "primary",
                    callback: () => this.finishHomeVisitProccess(TECHNICIAN_SIGNATURE)
                  };
                  break;
              }
            } else {
              leftButton = {
                text: "Finalizar",
                color: "primary",
                callback: () => this.finishHomeVisitProccess(TECHNICIAN_SIGNATURE)
              };
            }
          } else {
            leftButton = {
              text: this.props.mainState.isStartingHomeVisit ? <div><i className="now-ui-icons arrows-1_refresh-69 spin" /> Uniéndome </div> : "Unirme",
              color: "primary",
              disabled: this.props.mainState.isStartingHomeVisit,
              callback: this.startHomeVisit
            };
          }
          rightButton = {
            text: "Salir",
            color: "default",
            callback: this.exitHomeVisit
          };
          break;
          // Finalizada
        case 249:
          leftButton = {
            text: "Salir",
            color: "default",
            callback: this.exitHomeVisit
          };
          break;
        default:
          leftButton = {
            text: "Error al cargar las opciones",
            color: "default",
            callback: null
          };
          break;
      }
    }
    
    if (leftButton) {
      leftButton = (
        <Button
          color={leftButton.color}
          size="lg"
          block
          onClick={leftButton.callback}
          disabled={leftButton.disabled}
        >
          {leftButton.text}
        </Button>
      );
    }
    
    if (rightButton) {
      rightButton = (
        <Button
          color={rightButton.color}
          size="lg"
          block
          onClick={rightButton.callback}
          disabled={rightButton.disabled}
        >
          {rightButton.text}
        </Button>
      );
    }
    
    if (deleteButton) {
      deleteButton = (
        <Col xs={12} className="text-left">
          <Button
            color={deleteButton.color}
            size="lg"
            block
            onClick={deleteButton.callback}
            disabled={deleteButton.disabled}
          >
            {deleteButton.text}
          </Button>
        </Col>
      );
    }
    if (this.state.confirmingDelete) {
      deleteButton = (
        <Row around="xs" className="text-center">
          {/* <Label>¿Seguro que quieres eliminarla?</Label> */}
          <Col key={"confirmDeleteButton"} xs={6} className="text-left">
            <Button
              color={"danger"}
              size="lg"
              block
              onClick={this.deleteHomeVisit}
            >
              {"Sí"}
            </Button>
          </Col>
          <Col key={"cancelDeleteButton"} xs={6} className="text-right">
            <Button
              color={"default"}
              size="lg"
              block
              onClick={this.cancelDeleteHomeVisit}
            >
              {"No"}
            </Button>
          </Col>
        </Row>
      );
    }
    if (editButton) {
      editButton = (
        <Col xs={12} className="text-left">
          <Button
            color={editButton.color}
            size="lg"
            block
            onClick={editButton.callback}
            disabled={editButton.disabled}
          >
            {editButton.text}
          </Button>
        </Col>
      );
    }

    if (this.state.finishingStep === CUSTOMER_SIGNATURE) rightButton = null;
    if (this.state.finishingStep === FINISHED_HOME_VISIT) rightButton = null;

    let buttonsCount = 0;
    if (leftButton) ++buttonsCount;
    if (rightButton) ++buttonsCount;

    if (this.props.userData.isTechnician()) {
      deleteButton = null;
      editButton = null;
    }
    let footer = (
      <div>
        <Row>
          <Col xs={12}>
            <Card className="text-center">
              <CardBody className="text-right">
                <Row around="xs" /*className="align-items-center"*/>
                  {leftButton && <Col xs={12/buttonsCount} className="text-left">
                    {leftButton}
                  </Col>}
                  {rightButton && <Col xs={12/buttonsCount} className="text-right">
                    {rightButton}
                  </Col>}
                </Row>
              </CardBody>
            </Card>
          </Col>
          {editButton && <Col xs={12}>
            <Card className="text-center">
              <CardBody className="text-right">
                {editButton}
              </CardBody>
            </Card>
          </Col>}
          {deleteButton && <Col xs={12}>
            <Card className="text-center">
              {this.state.confirmingDelete && <CardHeader><CardTitle>¿Seguro que quieres eliminarla?</CardTitle></CardHeader>}
              <CardBody className="text-right">
                {deleteButton}
              </CardBody>
            </Card>
          </Col>}
        </Row>
      </div>
    );

    return footer;
  }
  buildCustomerType() {
    let customerType = (
      <Card className="text-center">
        <CardHeader>
          <CardTitle tag="h4" className="text-center">Tipo de cliente</CardTitle>
        </CardHeader>
        <CardBody className="text-right">
          <Row around="xs" className="align-items-center">
            <Col xs={12}>
              <FormGroup>
                <Select
                  className="react-select primary text-center"
                  classNamePrefix="react-select"
                  placeholder="Selecciona un tipo"
                  name="tipo"
                  value={this.state.customerData.customerType || ""}
                  options={customerTypeOptions}
                  onChange={value => {
                    let aux = this.state.customerData;
                    aux.customerType = value;
                    this.setState({ customerData: aux });
                  }}
                />
                <br></br>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
    return customerType;
  }
  buildCustomerBasicData() {
    let fiscalIdTypeField = null;
    let managerFields = null;
    let notEnterpriseFields = null;
    console.log(this.state);
    if (this.state.customerData.customerType.value !== "90") {
      fiscalIdTypeField = (
        <Col xs={12} sm="6">
          {/* Necesario que esté duplicado el FormGroup para que no coga el valor del select anterior (tipo de cliente) */}
          <FormGroup style={{display:"none"}}>
            <Select
              className="react-select primary text-center"
              classNamePrefix="react-select"
              placeholder="Tipo de documento"
              name="fiscalIdType"
              value={this.state.customerData.fiscalIdType || ""}
              options={fiscalIdTypeOptions}
              onChange={value => {
                let aux = this.state.customerData;
                aux.fiscalIdType = value;
                this.setState({ customerData: aux });
              }}
            />
          </FormGroup>
          <FormGroup>
            <Select
              className="react-select primary text-center"
              classNamePrefix="react-select"
              placeholder="Tipo de documento"
              name="fiscalIdType"
              value={this.state.customerData.fiscalIdType || ""}
              options={fiscalIdTypeOptions}
              onChange={value => {
                let aux = this.state.customerData;
                aux.fiscalIdType = value;
                this.setState({ customerData: aux });
              }}
            />
          </FormGroup>
        </Col>
      );
      notEnterpriseFields = [];
      notEnterpriseFields.push(
        <Col xs={12} sm="6" key="lastname">
          <InputGroup
            className={
              "form-control-lg " +
              (this.state.fieldStates["lastname"] || "") +
              (this.state.lastnameFocus ? " input-group-focus" : "")
            }
          >
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="now-ui-icons text_caps-small" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              value={this.state.customerData.lastname || ""}
              type="text"
              placeholder="Primer apellido"
              name="lastname"
              onFocus={e => this.setState({ lastnameFocus: true })}
              onBlur={e => this.setState({ lastnameFocus: false })}
              onChange={e => {
                e = e.target.value;
                let aux = this.state.customerData;
                aux.lastname = e;
                this.setState({ customerData: aux });
                this.validateField("lastname", e);
              }}
            />
          </InputGroup>
        </Col>
      );
      notEnterpriseFields.push(
        <Col xs={12} sm="6" key="lastname2">
          <InputGroup
            className={
              "form-control-lg " +
              (this.state.fieldStates["lastname2"] || "") +
              (this.state.lastname2Focus ? " input-group-focus" : "")
            }
          >
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="now-ui-icons text_caps-small" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              value={this.state.customerData.lastname2 || ""}
              type="text"
              placeholder="Segundo apellido"
              name="lastname2"
              onFocus={e => this.setState({ lastname2Focus: true })}
              onBlur={e => this.setState({ lastname2Focus: false })}
              onChange={e => {
                e = e.target.value;
                let aux = this.state.customerData;
                aux.lastname2 = e;
                this.setState({ customerData: aux });
                this.validateField("lastname2", e);
              }}
            />
          </InputGroup>
        </Col>
      );
    } else {
      managerFields = (
        <Row className="justify-content-center">
          <Col xs={12} sm="12" className="text-center">
            <h5 className="info-text">Datos del gerente</h5>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["dniManager"] || "") +
                (this.state.dniManagerFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons users_circle-08" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.dniManager || ""}
                type="text"
                placeholder="DNI/NIE/NIF"
                name="dniManager"
                onFocus={e => this.setState({ dniManagerFocus: true })}
                onBlur={e => this.setState({ dniManagerFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.dniManager = e;
                  this.setState({ customerData: aux });
                  this.validateField("dniManager", e);
                }}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["firstnameManager"] || "") +
                (this.state.firstnameManagerFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons users_circle-08" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.firstnameManager || ""}
                type="text"
                placeholder="Nombre"
                name="firstnameManager"
                onFocus={e => this.setState({ firstnameManagerFocus: true })}
                onBlur={e => this.setState({ firstnameManagerFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.firstnameManager = e;
                  this.setState({ customerData: aux });
                  this.validateField("firstnameManager", e);
                }}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["lastnameManager"] || "") +
                (this.state.lastnameManagerFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons text_caps-small" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.lastnameManager || ""}
                type="text"
                placeholder="Primer apellido"
                name="lastnameManager"
                onFocus={e => this.setState({ lastnameManagerFocus: true })}
                onBlur={e => this.setState({ lastnameManagerFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.lastnameManager = e;
                  this.setState({ customerData: aux });
                  this.validateField("lastnameManager", e);
                }}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["lastname2Manager"] || "") +
                (this.state.lastname2ManagerFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons text_caps-small" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.lastname2Manager || ""}
                type="text"
                placeholder="Segundo apellido"
                name="lastname2Manager"
                onFocus={e => this.setState({ lastname2ManagerFocus: true })}
                onBlur={e => this.setState({ lastname2ManagerFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.lastname2Manager = e;
                  this.setState({ customerData: aux });
                  this.validateField("lastname2Manager", e);
                }}
              />
            </InputGroup>
          </Col>
        </Row>
      );
    }
    let basicData = (
      <Card className="text-center">
        <CardHeader>
          <CardTitle tag="h4" className="text-center">Datos básicos</CardTitle>
        </CardHeader>
        <CardBody className="text-right">
          <Row className="justify-content-center">
            {/* <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg" +
                  (this.state.promoCodeState ? this.state.promoCodeState : "") +
                  (this.state.promoCodeFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons education_atom" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.promoCode}
                  type="text"
                  placeholder="Código promocional"
                  name="promoCode"
                  onFocus={e => this.setState({ promoCodeFocus: true })}
                  onBlur={e => this.setState({ promoCodeFocus: false })}
                  onChange={e => this.promoCodeChange(e)}
                />
              </InputGroup>
            </Col> */}
            {fiscalIdTypeField}
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["dni"] || "") +
                  (this.state.dniFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons users_circle-08" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.dni || ""}
                  type="text"
                  placeholder={this.state.customerData.customerType.value !== "90" ? "DNI/NIE/Pasaporte" : "NIF de la empresa"}
                  name="dni"
                  onFocus={e => this.setState({ dniFocus: true })}
                  onBlur={e => this.setState({ dniFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.dni = e;
                    this.setState({ customerData: aux });
                    this.validateField("dni", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["firstname"] || "") +
                  (this.state.firstnameFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons users_circle-08" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.firstname || ""}
                  type="text"
                  placeholder={this.state.customerData.customerType.value !== "90" ? "Nombre" : "Nombre de la empresa"}
                  name="firstname"
                  onFocus={e => this.setState({ firstnameFocus: true })}
                  onBlur={e => this.setState({ firstnameFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.firstname = e;
                    this.setState({ customerData: aux });
                    this.validateField("firstname", e);
                  }}
                />
              </InputGroup>
            </Col>
            {notEnterpriseFields}
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["mobile"] || "") +
                  (this.state.mobileFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons tech_mobile" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.mobile || ""}
                  type="number"
                  placeholder="Móvil"
                  name="mobile"
                  onFocus={e => this.setState({ mobileFocus: true })}
                  onBlur={e => this.setState({ mobileFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.mobile = e;
                    this.setState({ customerData: aux });
                    this.validateField("mobile", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["email"] || "") +
                  (this.state.emailFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons ui-1_email-85" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.email || ""}
                  type="email"
                  placeholder="Email"
                  name="email"
                  onFocus={e => this.setState({ emailFocus: true })}
                  onBlur={e => this.setState({ emailFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.email = e;
                    this.setState({ customerData: aux });
                    this.validateField("email", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["iban"] || "") +
                  (this.state.emailFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons business_bank" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.iban || ""}
                  type="text"
                  placeholder="IBAN cuenta bancaria"
                  name="iban"
                  onFocus={e => this.setState({ ibanFocus: true })}
                  onBlur={e => this.setState({ ibanFocus: false })}
                  onChange={event => {
                    try {
                      const caret = event.target.selectionStart;
                      const element = event.target;
                      const realCaret = this.formatIBAN(event.target.value.substring(0,caret)).length;
                      window.requestAnimationFrame(() => {
                        element.selectionStart = realCaret;
                        element.selectionEnd = realCaret;
                      });
                    } catch (e) {}

                    let newIBAN = this.formatIBAN(event.target.value);
                    let aux = this.state.customerData;
                    aux.iban = newIBAN;
                    this.setState({ customerData: aux });
                    this.validateField("iban", newIBAN);
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
          {managerFields}
        </CardBody>
      </Card>
    );
    return basicData;
  }
  buildCustomerAddress() {
    let customerAddress = (
      <Card className="text-center" >
        <CardHeader>
          <CardTitle tag="h4" className="text-center">Dirección</CardTitle>
        </CardHeader>
        <CardBody className="text-right">
          <Row around="xs" className="align-items-center">
          <Col xs={12} sm="12">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["street"] || "") +
                (this.state.streetFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons business_badge" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.street || ""}
                type="text"
                placeholder="Dirección (Calle, número...)"
                name="street"
                onFocus={e => this.setState({ streetFocus: true })}
                onBlur={e => this.setState({ streetFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.street = e;
                  this.setState({ customerData: aux });
                  this.validateField("street", e);
                }}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["locality"] || "") +
                (this.state.cityFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons location_compass-05" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.locality || ""}
                type="text"
                placeholder="Localidad"
                name="locality"
                onFocus={e => this.setState({ cityFocus: true })}
                onBlur={e => this.setState({ cityFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.locality = e;
                  this.setState({ customerData: aux });
                  this.validateField("locality", e);
                }}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["postalCode"] || "") +
                (this.state.postalCodeFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons location_pin" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.postalCode || ""}
                type="number"
                placeholder="Código postal"
                name="postalCode"
                onFocus={e => this.setState({ postalCodeFocus: true })}
                onBlur={e => this.setState({ postalCodeFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.postalCode = e;
                  this.setState({ customerData: aux });
                  this.validateField("postalCode", e);
                }}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["province"] || "") +
                (this.state.provinceFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons location_map-big" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.province || ""}
                type="text"
                placeholder="Provincia"
                name="province"
                onFocus={e => this.setState({ provinceFocus: true })}
                onBlur={e => this.setState({ provinceFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.province = e;
                  this.setState({ customerData: aux });
                  this.validateField("province", e);
                }}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["comunity"] || "") +
                (this.state.comunityFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons location_world" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.comunity || ""}
                type="text"
                placeholder="Comunidad Autónoma"
                name="comunity"
                onFocus={e => this.setState({ comunityFocus: true })}
                onBlur={e => this.setState({ comunityFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.comunity = e;
                  this.setState({ customerData: aux });
                  this.validateField("comunity", e);
                }}
              />
            </InputGroup>
          </Col>
          </Row>
        </CardBody>
      </Card>
    );
    return customerAddress;
  }
  setUploadedPhoto(image, identifier, multipleImages, uploadPending) {
    if(multipleImages) {
      return this.addPhoto(image);
    }
    if (uploadPending) {
      this.addPhoto(null, uploadPending);
      return;
    }
    let homeVisitPhotos = this.state.homeVisit.visit_photos;
    let currentUser = this.props.mainState.user;
    let currentVisitPhoto = {
      text: "",
      date: moment().format('DD/MM/YYYY HH:mm:ss'),
      photo: image,
      author: {
        fiscal_id: currentUser.field_dni.und[0].value,
        id: currentUser.uid,
        mail: currentUser.mail,
        name: currentUser.field_nombre_completo.und[0].value,
        picture: currentUser.picture,
        username: currentUser.name
      }
    };
    let newPhoto = null;
    if (identifier === NEW_PHOTO) {
      if (this.state.newPhoto) {
        newPhoto = this.state.newPhoto;
        newPhoto.photo = image;
        this.setState({ newPhoto: newPhoto });
      } else {
        this.setState({ newPhoto: { photo: image } });
      }
    } else {
      if (!homeVisitPhotos) homeVisitPhotos = [];
      if (identifier in homeVisitPhotos) {
        currentVisitPhoto = homeVisitPhotos[identifier];
        currentVisitPhoto.photo = image;
      }
      homeVisitPhotos[identifier] = currentVisitPhoto;
      let homeVisit = this.state.homeVisit;
      homeVisit.visit_photos = homeVisitPhotos;
      this.setState({ homeVisit: homeVisit });
    }
  }
  changeHappiness(emoji) {
    this.setState({ happiness: emoji });
  }
  getReasonStyle(reason) {
    let style = {
      borderRadius: "15px",
      padding: "5px 10px",
      color: "#FFF",
      overflow: "hidden"
    };
    let icon = "";
    switch (reason) {
      // Todo correcto: verde
      case 257:
        style.background = "#00BA89";
        icon = "ui-1_check";
        break;
        // Visita pospuesta: azul
      case 261:
        style.background = "#ffb142";
        icon = "ui-1_calendar-60";
        break;
        // Incidencia ajena: amarilla
      case 260:
        style.background = "#34ace0";
        icon = "objects_support-17";
        break;
        // Incidencia propia: rojo
      case 259:
        style.background = "#b33939";
        icon = "ui-2_settings-90";
        break;
        // Cancelada: naranja
      case 258:
        style.background = "#ff793f";
        icon = "ui-1_simple-remove";
        break;    
      default:
        style.background = "#84817a";
        icon = "ui-1_settings-gear-63";
        break;
    }
    return {
      style: style,
      icon: icon
    };
  }
  buildSignature() {
    let signatureField = (
      <Card key="signatureField" className="text-center" >
        <CardHeader>
          <CardTitle tag="h4" className="text-center">{this.state.finishingStep === CUSTOMER_SIGNATURE ? "Firma del cliente" : "Firma del técnico"}</CardTitle>
        </CardHeader>
        <CardBody className="text-right">
          <Row around="xs" className="align-items-center">
            <Col xs={12}>
              <SignatureCanvas 
                ref={ref => {
                  this.signature = ref;
                }}
                // ref="signature"
                penColor="black"
                canvasProps={{width: window.innerWidth - 90, height: 250, className: 'sigCanvas'}} 
                onEnd={this.saveSignature}
                clearOnResize={false}
                /> 
            </Col>
            <Col xs={12}>
              {this.signature && !this.signature.isEmpty() && <Button
                color="default"
                size="lg"
                onClick={() => {
                  this.clearSignature();
                }}
              >
                {"Borrar firma"}
              </Button>}
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
    let happiness = null;
    let customerComments = null;
    let finishReason = null;
    let commentToSave = "commentText";
    let showCustomerComment = false;
    let showTechnicianComment = false;
    let commentTitle = "¿Algún comentario?";
    let technicianComments = null;
    if (this.state.finishingStep === CUSTOMER_SIGNATURE) {
      showCustomerComment = true;
      let happySize = {
        xs: 2
      };
      happiness = (
        <Card>
          <CardHeader>
            <CardTitle className="text-center">
              ¿Qué te ha parecido?
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row style={{ marginBottom: "25px" }}>
              <Col xs={12} style={{ fontSize: "60px" }} className="text-center">
                {this.state.happiness ? this.state.happiness.icon : "👽"}
                <br />
              </Col>
            </Row>
            <Row className="justify-content-md-center text-center">
              {Object.keys(emojis).map((currentHappiness) => {
                let emoji = emojis[currentHappiness];
                let emojiStyle = {fontSize: "30px", cursor: "pointer", width: "20%"};
                if (this.state.happiness && this.state.happiness.value === emoji.value) emojiStyle.opacity = "0.3";
                return (
                  <span 
                    key={emoji.value + "-happiness"}
                    {...happySize}
                    onClick={() => this.changeHappiness(emoji)}
                    style={emojiStyle}
                  >
                    {emoji.icon}
                  </span>
                );
              })}
            </Row>
          </CardBody>
        </Card>
      );
    }
    if (this.state.finishingStep === TECHNICIAN_SIGNATURE) {
      let reasons = null;
      if (this.props.mainState.homeVisitFinishReasonList) {
        reasons = this.props.mainState.homeVisitFinishReasonList.map(reason => {
          let value = parseInt(reason.value);
          let label = reason.label;
          let reasonStyle = this.getReasonStyle(value);
          let iconStyle = {
            padding: "5px 10px",
            marginRight: "10px",
            background: "rgba(0,0,0,0.1)",
            borderRadius: "15px",
            marginLeft: "-10px"
          }
          return {
            value: value,
            label: (
              <div style={{ display: "block" }}>
                <span style={reasonStyle.style}>
                  <span style={iconStyle}><i className={"now-ui-icons " + reasonStyle.icon} /></span>
                  {label}
                </span>
              </div>)
          }
        })
      }
      finishReason = (
        <Col xs={12}>
          <Select
            className="react-select primary"
            classNamePrefix="react-select"
            placeholder="Elegir motivo"
            name="selectedFinishingReason"
            value={this.state.finishReason}
            options={reasons}
            noOptionsMessage={() => <span>No se han cargado los motivos</span>}
            onChange={value =>{
              // console.log("######## CAMBIO CLIENTE ######");
              // console.log(value);
              this.setState({ finishReason: value });
            }}
          />
        </Col>
      );
      finishReason = (
        <Card>
          <CardHeader>
            <CardTitle className="text-center">
              Motivo de finalización
            </CardTitle>
          </CardHeader>
          <CardBody>
            {finishReason}
          </CardBody>
        </Card>
      );
      
      if (this.state.finishReason && this.state.finishReason.value !== 257) {
        showTechnicianComment = true;
      }
    }
    customerComments = (
      <Card style={{ display: showCustomerComment ? "block": "none" }}>
        <CardHeader>
          <CardTitle className="text-center">
            {commentTitle}
          </CardTitle>
        </CardHeader>
        <CardBody>
          <CKEditor
            editor={ ClassicEditor }
            config={{
              toolbar: [
                'heading', '|',
                'bold', 'italic','|',
                'link', '|',
                'outdent', 'indent', '|',
                'bulletedList', 'numberedList', '|',
                'insertTable', '|',
                'blockQuote', '|',
                'undo', 'redo'
              ]
            }}
            data={this.state[commentToSave]}
            onInit={ editor => {
            } }
            onChange={ ( event, editor ) => {
                const data = editor.getData();
                this.setState({ [commentToSave]: data });
            } }
          />
        </CardBody>
      </Card>
    );
    technicianComments = (
      <Card style={{ display: showTechnicianComment ? "block": "none" }}>
        <CardHeader>
          <CardTitle className="text-center">
            ¿Por qué no está todo correcto?
          </CardTitle>
        </CardHeader>
        <CardBody>
          <CKEditor
            editor={ ClassicEditor }
            config={{
              toolbar: [
                'heading', '|',
                'bold', 'italic','|',
                'link', '|',
                'outdent', 'indent', '|',
                'bulletedList', 'numberedList', '|',
                'insertTable', '|',
                'blockQuote', '|',
                'undo', 'redo'
              ]
            }}
            data={this.state.commentTextTechnician}
            onInit={ editor => {
            } }
            onChange={ ( event, editor ) => {
                const data = editor.getData();
                if (this.state.finishingStep === TECHNICIAN_SIGNATURE) {
                  this.setState({ commentTextTechnician: data });
                }
            } }
          />
        </CardBody>
      </Card>
    );
    return (
      <Row>
        {happiness}
        {finishReason}
        {customerComments}
        {technicianComments}
        {signatureField}
      </Row>);
  }
  buildContentBAK() {
    let content = null;
    switch (this.state.currentStep) {
      case PRODUCTOS:
        content = this.buildContractProducts();
        break;
      case TIPO_CLIENTE:
        content = this.buildCustomerType();
        break;
      case DATOS_BASICOS:
        content = this.buildCustomerBasicData();
        break;
      case DIRECCION:
        content = this.buildCustomerAddress();
        break;
      case FIRMA:
        content = this.buildCustomerSignature();
        break;
      default:
        break;
    }
    return content;
  }
  clearSignature() {
    if (this.signature) this.signature.clear();
    if (this.state.finishingStep === CUSTOMER_SIGNATURE) {
      this.setState({ signature: null });
    } else {
      this.setState({ signatureTechnician: null });
    }
  }
  buildExistingCustomer() {
    let result = null;
    let isTechnician = this.props.userData.isTechnician();

    if (this.state.homeVisit && this.state.homeVisit.customer) {
      let customer = this.state.homeVisit.customer;
      // console.log("home visit customer", customer);
      if (customer.id === 1) {
        result = (
          <Row>
            <Col xs={12}>
              <Card className="text-center text-black" color="primary">
                <CardHeader>
                  <CardTitle tag="h4" className="text-center text-black"></CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="text-center">
                    <i className="now-ui-icons ui-2_settings-90" /> Trabajos propios
                  </div>
                  <br />
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      } else {
        let formattedNumber = "";
        if (customer.phone) {
          formattedNumber =
            customer.phone.substring(0, 3) +
            " " +
            customer.phone.substring(3, 6) +
            " " +
            customer.phone.substring(6, 9);
        }
  
        result = (
          <Row className="justify-content-center">
            <Col xs={12} className="existing-user-table">
              <Button
                block
                onClick={() => {
                  if (!isTechnician) {
                    this.setState({ redirect: "/clientes/fichas/".concat(customer.id) });
                  }
                }}
              >              
                <Table responsive>
                  <tbody>
                    <tr key={customer.id}>
                      {/* <td className="text-center">
                        {activeCustomerButton}
                      </td> */}
                      <td className="text-center">
                        {customer.name}
                      </td>
                      <td className="text-center">
                        <a href={"tel:" + customer.phone}>{formattedNumber}</a>                        
                      </td>
                      {!isTechnician && <td className="text-center">{customer.fiscal_id}</td>}
                      {/*<td className="text-left">{customer.email}</td>*/}
                      {!isTechnician && <td className="text-center">{customer.mail}</td>}
                      {/* <td className="text-left">{customer.distribuidor}</td> */}
                      {/* <td className="text-center">{servicesButtons}</td> */}
                      {/* order.data.map((prop, key) => {
                        if (key === thead.length - 1)
                          return (
                            <td key={key} className="text-right">
                              {prop}
                            </td>
                          );
                        return <td key={key}>{prop}</td>;
                      }) */}
                    </tr>
                  </tbody>
                </Table>
              </Button>
            </Col>
          </Row>
        );
      }
    } else {
      result = (
        <Row>
          <Col xs={12}>
            <Card className="text-center text-black" color="warning">
              <CardHeader>
                <CardTitle tag="h4" className="text-center text-black">Cliente existente</CardTitle>
              </CardHeader>
              <CardBody>
                <div className="text-center">
                  <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando datos del cliente...
                </div>
                <br />
              </CardBody>
            </Card>
          </Col>
        </Row>
      );
    }

    return result;
  }
  buildRelatedContract() {
    let homeVisit = this.state.homeVisit;
    if (!homeVisit.has_contract) return null;
    let isTechnician = this.props.userData.isTechnician();
    let result = null;
    result = (
      <Row className="justify-content-center">
        <Col xs={12} className="existing-user-table">
          <Button
            block
            onClick={() => {
              if (!isTechnician) {
                this.redirectTo("/contratos/".concat(homeVisit.related_contract.value));
              }
            }}
          >              
            <Table responsive>
              <tbody>
                <tr>
                  {/* <td className="text-center">
                    {activeCustomerButton}
                  </td> */}
                  <td className="text-center">
                    <b>Contrato:</b>
                  </td>
                  <td className="text-center">
                    {homeVisit ? (homeVisit.related_contract ? homeVisit.related_contract.label : "Error al cargar el contrato") : "Error al cargar el contrato"}                      
                  </td>
                </tr>
              </tbody>
            </Table>
          </Button>
        </Col>
      </Row>
    );

    return result;
  }
  cancelAddComment() {
    this.setState({
      showNewCommentBox: false,
      commentText: null
    });
  }
  addComment() {
    let comments = this.state.homeVisit.visit_comments;
    let currentUser = this.props.mainState.user;
    if (!comments) comments = [];
    let newComment = {
      pending: true,
      text: this.state.commentText,
      date: moment().format('DD/MM/YYYY HH:mm:ss'),
      author: {
        fiscal_id: currentUser.field_dni.und[0].value,
        id: currentUser.uid,
        mail: currentUser.mail,
        name: currentUser.field_nombre_completo.und[0].value,
        picture: currentUser.picture,
        username: currentUser.name
      }
    };
    console.log("############ NUEVO COMENTARIO ##############");
    console.log(newComment);
    comments.push(newComment);

    let homeVisit = this.state.homeVisit;
    homeVisit.visit_comments = comments;
    this.setState({
      showNewCommentBox: false,
      commentText: null,
      homeVisit: homeVisit
    });
    this.props.userData.addHomeVisitComment({
      home_visit_id: this.state.homeVisitId,
      comment: newComment
    });
  }
  cancelAddPhoto() {
    this.setState({
      showNewPhotoBox: false,
      photoText: null,
      newPhoto: null
    });
  }
  addPhoto(multiplePhotos, uploadPending) {
    if (uploadPending) {
      let pendingPhotos = [];
      // console.log("uploadPending",uploadPending);
      // console.log("this.state.homeVisit.visit_photos.length", this.state.homeVisit.visit_photos.length);
      this.state.homeVisit.visit_photos.map(currentPhoto => {
        // console.log("currentPhoto", currentPhoto);
        // console.log("currentPhoto.pending", currentPhoto.pending);
        if (currentPhoto.pending) pendingPhotos.push(currentPhoto);
      });
      // console.log("Justo antes de llamar addHomeVisitPhoto", {
      //   home_visit_id: this.state.homeVisitId,
      //   photo: pendingPhotos
      // });
      // return;
      this.props.userData.addHomeVisitPhoto(
        {
          home_visit_id: this.state.homeVisitId,
          photos: pendingPhotos
        },
        true //isMultiple
      );
      return;
    }
    // console.log("############ AÑADIR FOTO - STATE ##############");
    // console.log(this.state);
    if(multiplePhotos) {
      // console.log("Add multiple photos", multiplePhotos);
      // console.log("multiple photos length", multiplePhotos.length);
      let homeVisit = this.state.homeVisit;
      // for (let i = 0; i < multiplePhotos.length; i++) {
      // console.log("Adding photo " + i);
      // let currentPhoto = multiplePhotos[i];  
      let currentPhoto = multiplePhotos;
      let photos = this.state.homeVisit.visit_photos;
      let currentUser = this.props.mainState.user;
      // console.log("multiple photos currentUser", currentUser);
      if (!photos) photos = [];
      let newPhoto = {
        pending: true,
        id: generateRandomID(),
        text: null,
        photo: currentPhoto,
        date: moment().format('DD/MM/YYYY HH:mm:ss'),
        author: {
          fiscal_id: currentUser.field_dni.und[0].value,
          id: currentUser.uid,
          mail: currentUser.mail,
          name: currentUser.field_nombre_completo.und[0].value,
          picture: currentUser.picture,
          username: currentUser.name
        }
      };
      // console.log("Nueva foto", newPhoto);
      // console.log("############ NUEVA FOTO ##############");
      // console.log(newPhoto);
      photos.push(newPhoto);
  
      homeVisit.visit_photos = photos;
      // let pendingPhotos = this.state.pendingPhotos;
      // if(!pendingPhotos) pendingPhotos = [];
      // pendingPhotos.push(newPhoto);
      // console.log("pendingPhotos", pendingPhotos);
      // console.log("############ NUEVA FOTO - homeVisit ##############");
      // console.log(homeVisit);
      // this.props.userData.addHomeVisitPhoto({
      //   home_visit_id: this.state.homeVisitId,
      //   photo: newPhoto
      // });
      // }
      this.setState({
        showNewPhotoBox: false,
        photoText: null,
        newPhoto: null,
        homeVisit: homeVisit,
        showPhotos: true
      });
      return newPhoto;
    } 
    else {
      if (!this.state.newPhoto || !this.state.newPhoto.photo) {
        console.log("############ NO SE PUEDE AÑADIR - FOTO VACÍA ##############");
        return;
      }
  
      let photos = this.state.homeVisit.visit_photos;
      let currentUser = this.props.mainState.user;
      if (!photos) photos = [];
      let newPhoto = {
        pending: true,
        id: generateRandomID(),
        text: this.state.photoText,
        photo: this.state.newPhoto.photo,
        date: moment().format('DD/MM/YYYY HH:mm:ss'),
        author: {
          fiscal_id: currentUser.field_dni.und[0].value,
          id: currentUser.uid,
          mail: currentUser.mail,
          name: currentUser.field_nombre_completo.und[0].value,
          picture: currentUser.picture,
          username: currentUser.name
        }
      };
      // console.log("############ NUEVA FOTO ##############");
      // console.log(newPhoto);
      photos.push(newPhoto);
  
      let homeVisit = this.state.homeVisit;
      homeVisit.visit_photos = photos;
      // console.log("############ NUEVA FOTO - homeVisit ##############");
      // console.log(homeVisit);
      this.setState({
        showNewPhotoBox: false,
        photoText: null,
        newPhoto: null,
        homeVisit: homeVisit
      });
      this.props.userData.addHomeVisitPhoto({
        home_visit_id: this.state.homeVisitId,
        photo: newPhoto
      });
    }
  }
  activateEditPhoto(key) {
    let photos = this.state.homeVisit.visit_photos;
    let photoToEdit = photos[key];
    photoToEdit.editing = true;

    photos[key] = photoToEdit;

    let homeVisit = this.state.homeVisit;
    homeVisit.visit_photos = photos;

    this.setState({
      homeVisit: homeVisit
    });
  }
  activateDeletePhoto(key) {
    let photos = this.state.homeVisit.visit_photos;
    let photoToDelete = photos[key];
    photoToDelete.deleteCheck = true;

    photos[key] = photoToDelete;

    let homeVisit = this.state.homeVisit;
    homeVisit.visit_photos = photos;

    this.setState({
      homeVisit: homeVisit
    });
  }
  activateDeletingPhoto(key) {
    let photos = this.state.homeVisit.visit_photos;
    let photoToDelete = photos[key];
    photoToDelete.deleting = true;

    photos[key] = photoToDelete;

    let homeVisit = this.state.homeVisit;
    homeVisit.visit_photos = photos;

    this.setState({
      homeVisit: homeVisit
    });
  }
  deactivateDeletePhoto(key) {
    let photos = this.state.homeVisit.visit_photos;
    let photoToDelete = photos[key];
    photoToDelete.deleteCheck = false;

    photos[key] = photoToDelete;

    let homeVisit = this.state.homeVisit;
    homeVisit.visit_photos = photos;

    this.setState({
      homeVisit: homeVisit
    });
  }
  editPhotoText(key, data) {
    let photos = this.state.homeVisit.visit_photos;
    let editingPhoto = photos[key];
    editingPhoto.text = data;

    photos[key] = editingPhoto;

    let homeVisit = this.state.homeVisit;
    homeVisit.visit_photos = photos;

    this.setState({
      homeVisit: homeVisit
    });
  }
  saveEditedPhoto(photo) {
    // console.log("######## test guardar foto editada ##########");
    // console.log(photo);
    this.props.userData.editHomeVisitPhoto({
      home_visit_id: this.state.homeVisitId,
      photo: photo
    });
  }
  deletePhoto(photo) {
    // console.log("######## test guardar foto editada ##########");
    // console.log(photo);
    photo = {
      id: photo.id
    };
    this.props.userData.deleteHomeVisitPhoto({
      home_visit_id: this.state.homeVisitId,
      photo: photo
    });
  }
  buildComments() {
    if (this.props.userData.isTechnician() && !this.isTechnicianWorking()) return null;
    let result = null;
    let homeVisit = this.state.homeVisit;
    let count = 0;
    if (homeVisit.visit_comments && homeVisit.visit_comments.length) count = homeVisit.visit_comments.length;

    let commentsCardHeader = (
      <Card color="info" className="header-content-home-visit">
        <CardHeader
          className="txt-white"
          onClick={() => {
            this.setState({ showComments: !this.state.showComments });
          }}
        >
          <h5>
            <i className="now-ui-icons design-2_ruler-pencil" /> Comentarios{"  "}
            <span className="home-visit-count">{count}</span>
            <span className="home-visit-count-click" style={{ fontSize: "2em" }}>{this.state.showComments ? "-" : "+"}</span>
          </h5>
        </CardHeader>
      </Card>
    );

    let commentsCard = null;
    let commentsCardBody = null;
    if (this.state.showComments) {
      if (homeVisit.visit_comments && homeVisit.visit_comments.length > 0) {
        let visitComments = homeVisit.visit_comments;
        if (!visitComments) visitComments = [];
        if (visitComments.length > 0) {
          visitComments = visitComments.sort((a, b) => {
            let momentA = new moment(a.date, "DD/MM/YYYY HH:mm:ss");
            let momentB = new moment(b.date, "DD/MM/YYYY HH:mm:ss");
            // Newer first
            return momentB - momentA;
          });
          visitComments = visitComments.map((comment, key) => {
            let badgeStyle = 
            {
              color: "default",
              icon: "travel_info"
            };
            // if (comment.tipo === "Incidencia") {
            //   badgeStyle.color = "danger";
            //   badgeStyle.icon = "ui-2_settings-90";
            // }
            // if (comment.tipo === "Solución") {
            //   badgeStyle.color = "primary";
            //   badgeStyle.icon = "ui-2_like";
            // }
            // if (comment.tipo === "Log") {
            //   badgeStyle.color = "warning";
            //   badgeStyle.icon = "ui-1_bell-53";
            // }
            // if (comment.tipo === "Pago") {
            //   badgeStyle.color = "primary";
            //   badgeStyle.icon = "business_money-coins";
            // }
  
            return {
              inverted: true,
              badgeColor: comment.pending ? "warning" : badgeStyle.color,
              badgeUserPicture: !comment.pending? (comment.author.picture || "no-tiene") : null,
              badgeIcon: comment.pending ? "now-ui-icons arrows-1_refresh-69 spin" : null,
              title: comment.author.username,
              titleColor: comment.pending ? "warning" : "primary",
              body: <div dangerouslySetInnerHTML={{ __html: comment.text }} />,
              footerTitle: moment(comment.date, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY HH:mm"),
              footerIcon: "now-ui-icons ui-1_calendar-60"
            };
          });
          commentsCardBody =
            <CardBody>
              <Timeline stories={visitComments} simple />
            </CardBody>;
        } else {
          commentsCardBody = 
            <CardBody>
              <div>
                <i className="now-ui-icons ui-1_simple-remove" /> No hay comentarios...
              </div>
            </CardBody>;
        }
      } else {
        commentsCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons ui-1_simple-remove" /> No hay comentarios...
            </div>
          </CardBody>;
      }
    }
    commentsCard = (
      <Card key="commentsCard" className="card-plain card-timeline">
        {commentsCardHeader}
        {this.state.showNewCommentBox ? 
          <Row>
            <Col xs={12} style={{ padding: "0px 40px" }}>
              <FormGroup>
                <Button
                  // icon
                  // round
                  block
                  key={"cancelAddCommentButton"}
                  color="default"
                  onClick={() => {
                    this.cancelAddComment();
                  }}
                  // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                >Cancelar</Button>
                <CKEditor
                  editor={ ClassicEditor }
                  config={{
                    toolbar: [
                      'heading', '|',
                      'bold', 'italic','|',
                      'link', '|',
                      'outdent', 'indent', '|',
                      'bulletedList', 'numberedList', '|',
                      'insertTable', '|',
                      'blockQuote', '|',
                      'undo', 'redo'
                    ]
                  }}
                  data={this.state.commentText}
                  onInit={ editor => {
                  } }
                  onChange={ ( event, editor ) => {
                      const data = editor.getData();
                      this.setState({ commentText: data });
                  } }
                />
              </FormGroup>
              <Button
                // icon
                // round
                block
                key={"addCommentButton"}
                color="primary"
                onClick={() => {
                  this.addComment();
                }}
                // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
              >Añadir</Button>
            </Col>
          </Row>
          : <Button
            // icon
            round
            block
            key={"createCommentButton"}
            color="info"
            onClick={() => {
              this.setState({ showNewCommentBox: true });
            }}
            leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingHomeVisitComment ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
          >Nuevo comentario</Button>}
        {commentsCardBody}
      </Card>
    );

    result = commentsCard;

    return result;
  }
  getPhotoCount(photos) {
    if (!photos) return "0";
    let pendingPhotosCount = 0; 
    let photosCount = 0;
    if (photos && photos.length) {
      for (let i = 0; i < photos.length; i++) {
        const photo = photos[i];
        if (photo.pending) {
          pendingPhotosCount++;
        } else {
          photosCount++;
        }      
      }
    }
    let pendingText = null;
    if (pendingPhotosCount > 0) {
      pendingText = <span><i className={"now-ui-icons arrows-1_refresh-69 spin"} /> {" " + pendingPhotosCount}</span>;
    }
    if (photosCount === 0) {
      if (pendingText) {
        return pendingText;
      } else {
        return "0";
      }
    } else {
      if (pendingText) {
        return <span>{photosCount + " + "}{pendingText}</span>;
      } else {
        return <span>{photosCount}</span>;
      }
    }
  }
  buildPhotos() {
    if (this.props.userData.isTechnician() && !this.isTechnicianWorking()) return null;
    let result = null;
    let homeVisit = this.state.homeVisit;

    let photosCardHeader = (
      <Card color="warning" className="header-content-home-visit">
        <CardHeader
          className="txt-black"
          color="warning"
          onClick={() => {
            this.setState({ showPhotos: !this.state.showPhotos });
          }}
        >
          <h5>
            <i className="now-ui-icons design_image" /> Fotos{"  "}
            <span className="home-visit-count">{this.getPhotoCount(homeVisit.visit_photos)}</span>
            <span className="home-visit-count-click" style={{ fontSize: "2em" }}>{this.state.showPhotos ? "-" : "+"}</span>
          </h5>
        </CardHeader>
      </Card>
    );

    let photosCard = null;
    let photosCardBody = null;
    if (this.state.showPhotos) {
      if (homeVisit.visit_photos && homeVisit.visit_photos.length > 0) {
        let visitPhotos = homeVisit.visit_photos;
        // console.log("############ BUILD PHOTOS - visitPhotos ##############");
        // console.log(visitPhotos);
        if (!visitPhotos) visitPhotos = [];
        if (visitPhotos.length > 0) {
          visitPhotos = visitPhotos.sort((a, b) => {
            let momentA = new moment(a.date, "DD/MM/YYYY HH:mm:ss");
            let momentB = new moment(b.date, "DD/MM/YYYY HH:mm:ss");
            // Newer first
            return momentB - momentA;
          });
          visitPhotos = visitPhotos.map((photo, key) => {
            // console.log("############ BUILD PHOTOS CURRENT PHOTO - photo, key ##############");
            // console.log(photo);
            // console.log(key);
            let badgeStyle = 
            {
              color: "default",
              icon: "travel_info"
            };
            let buttonSize = {
              xs: 12,
              md: 12,
              // lg: 12
            };
            let imageSize = {
              xs: 6,
              md: 2,
              // lg: 1
            };
            let fullsizeImage = null;
            if (this.state.photoDetails === photo.id) {
              imageSize = {
                xs: 12,
              };
              fullsizeImage = " fullsize ";
            }


            return (
              <Col {...imageSize} key={photo.id}>
                <Card className="card-testimonial" color={photo.pending ? "warning" : (photo.deleteCheck || photo.deleting) ? "danger" : "white"}>
                  <CardHeader className={"card-header-avatar home-visit " + fullsizeImage}>
                    {/* <a href="#pablo">
                      <img className="img img-raised" src={avatar} alt="..." />
                    </a> */}
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (this.state.photoDetails !== photo.id) {
                          this.setState({ photoDetails: photo.id });
                        } else {
                          this.setState({ photoDetails: null });
                        }
                      }}
                    >
                      <ImageUpload 
                        getImage={this.setUploadedPhoto.bind(this)} 
                        existingImage={photo.photo}
                        imageIdentifier={key.toString()}
                        hideButtons={photo.pending}
                        hideDeleteButton
                        hideChangeButton={!photo.editing || this.state.photoDetails !== photo.id}
                        changeButtonText="Cambiar foto"
                      />
                    </div>
                  </CardHeader>
                  {(this.state.photoDetails === photo.id) && 
                  <div>
                    <CardBody className="text-black">
                    {photo.pending &&
                      <Row>
                        <Col className="text-center">
                          <h6>{"Subiendo foto"}</h6>
                        </Col>
                      </Row>}
                    {photo.deleteCheck &&
                      <Row>
                        <Col className="text-center">
                          <h6>{photo.deleting ? "Eliminando" : "¿Eliminar la foto?"}</h6>
                        </Col>
                      </Row>}
                    {this.state.homeVisit.visit_state.tid !== 249  && 
                      <Row>
                        {!(photo.deleteCheck || photo.editing || photo.author.id !== parseInt(this.props.mainState.user.uid)) && <Col {...buttonSize}>
                          <Button
                            // icon
                            // round
                            block
                            key={"activateEditPhotoButton"}
                            color={"default"}
                            onClick={() => {
                              this.activateEditPhoto(key);
                            }}>Editar</Button>
                        </Col>}
                        {!photo.deleting && <Col {...buttonSize}>
                          <Button
                            // icon
                            // round
                            hidden={photo.editing || photo.author.id !== parseInt(this.props.mainState.user.uid)}
                            block
                            key={"activateDeletePhotoButton"}
                            color={photo.deleteCheck ? "default" : "danger"}
                            onClick={() => {
                              if (photo.deleteCheck) {
                                this.activateDeletingPhoto(key);
                                this.deletePhoto(photo);
                              } else {
                                this.activateDeletePhoto(key);
                              }
                            }}>{photo.deleteCheck ? "Sí" : "Eliminar"}</Button>
                        </Col>}
                        {(photo.deleteCheck && !photo.deleting) && <Col {...buttonSize}>
                          <Button
                            // icon
                            // round
                            block
                            key={"cancelDeletePhotoButton"}
                            color={"primary"}
                            onClick={() => {
                              this.deactivateDeletePhoto(key);
                            }}>No</Button>
                        </Col>}
                      </Row>}
                      {!photo.deleteCheck && <CardDescription>
                        {photo.editing ? 
                          <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              toolbar: [
                                'heading', '|',
                                'bold', 'italic','|',
                                'link', '|',
                                'outdent', 'indent', '|',
                                'bulletedList', 'numberedList', '|',
                                'insertTable', '|',
                                'blockQuote', '|',
                                'undo', 'redo'
                              ]
                            }}
                            data={photo.text}
                            onInit={ editor => {
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                this.editPhotoText(key, data);
                            } }
                          />
                        : <span className="text-left" dangerouslySetInnerHTML={photo.pending || photo.deleting ? null : {__html: photo.text}} />
                        } 
                      </CardDescription>}
                      {(photo.pending) && <div className="icon icon-black text-black">
                        <i className={"now-ui-icons arrows-1_refresh-69 spin"} />
                      </div>}
                      {(photo.deleting) && <div className="icon icon-black text-black">
                        <i className={"now-ui-icons arrows-1_refresh-69 spin"} />
                      </div>}
                      <Button
                        // icon
                        // round
                        hidden={!photo.editing || photo.author.id !== parseInt(this.props.mainState.user.uid)}
                        // block
                        disabled={this.props.mainState.isEditingHomeVisitPhoto}
                        key={"activateEditPhotoButton"}
                        color={photo.editing ? "primary" : "default"}
                        onClick={() => {
                          if (photo.editing) {
                            this.saveEditedPhoto(photo);
                          } else {
                            this.activateEditPhoto(key);
                          }
                        }}
                        // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                      >{photo.editing ? this.props.mainState.isEditingHomeVisitPhoto ? <span><i className={"now-ui-icons arrows-1_refresh-69 spin"} /> Guardando</span> : "Guardar" : "Editar"}</Button>
                    </CardBody>
                    <CardFooter className="h-nomargin home-visit-footer">
                      <CardTitle tag="span">{photo.pending ? "Subiendo foto" : (photo.deleting ? "Eliminando foto" : photo.author.username)}</CardTitle>                  
                      <span className="category">
                        {" "}<i className={"now-ui-icons ui-1_calendar-60"} />{" "}
                        {photo.date}
                      </span>
                    </CardFooter>
                  </div>}
                  {(this.state.photoDetails !== photo.id && photo.pending) && 
                  <div>
                    <CardBody className="text-black" style={{ fontSize: "1em" }}>
                      <Row>
                        <Col className="text-center">
                          <i className={"now-ui-icons arrows-1_refresh-69 spin"} /><span>{"Subiendo foto"}</span>
                        </Col>
                      </Row>
                    </CardBody>
                  </div>}
                </Card>
              </Col>
            );
          });
          photosCardBody = visitPhotos;
        } else {
          photosCardBody = 
            <CardBody>
              <div>
                <i className="now-ui-icons ui-1_simple-remove" /> No hay fotos...
              </div>
            </CardBody>;
        }
      } else {
        photosCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons ui-1_simple-remove" /> No hay fotos...
            </div>
          </CardBody>;
      }
    }
    photosCard = (
        <Card key="photosCard" className="card-plain">
          {photosCardHeader}
          <Row>
            {this.state.showNewPhotoBox ? 
              <Col xs={12} md={6}>
                <Card className="card-testimonial" color="warning">
                  <CardHeader className="card-header-avatar home-visit">
                    {/* <a href="#pablo">
                      <img className="img img-raised" src={avatar} alt="..." />
                    </a> */}
                    <ImageUpload 
                      getImage={this.setUploadedPhoto.bind(this)} 
                      existingImage={this.state.newPhoto ? this.state.newPhoto.photo : null}
                      imageIdentifier={NEW_PHOTO}
                      hideDeleteButton
                    />
                  </CardHeader>
                  <CardBody>
                    <Button
                      // icon
                      // round
                      block
                      key={"cancelAddPhotoButton"}
                      color="danger"
                      onClick={() => {
                        this.cancelAddPhoto();
                      }}
                      // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    >Cancelar</Button>
                    <CKEditor
                      editor={ ClassicEditor }
                      config={{
                        toolbar: [
                          'heading', '|',
                          'bold', 'italic','|',
                          'link', '|',
                          'outdent', 'indent', '|',
                          'bulletedList', 'numberedList', '|',
                          'insertTable', '|',
                          'blockQuote', '|',
                          'undo', 'redo'
                        ]
                      }}
                      data={this.state.photoText}
                      onInit={ editor => {
                      } }
                      onChange={ ( event, editor ) => {
                          const data = editor.getData();
                          this.setState({ photoText: data });
                      } }
                    />
                  </CardBody>
                  <CardFooter>
                    <Button
                      // icon
                      // round
                      block
                      key={"addPhotoButton"}
                      color="primary"
                      onClick={() => {
                        this.addPhoto();
                      }}
                      // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    >Añadir</Button>
                  </CardFooter>
                </Card>
              </Col>
              : <Col xs={12} className="text-center">
              <Button
                  round
                  block
                  key={"createPhotoButton"}
                  color="warning"
                  className="txt-black"
                  onClick={() => {
                    this.setState({ showNewPhotoBox: true });
                  }}
                  leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingHomeVisitPhoto ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                >Agregar foto</Button><br />
              </Col>} 
            {photosCardBody}
          </Row>
        </Card>
    );

    result = photosCard;

    return result;
  }
  buildPictures() {
    let result = null;
    let homeVisit = this.state.homeVisit;

    let commentsCardHeader = (
      <Card color="white">
        <CardHeader className="txt-black">
          <h5>
            <i className="now-ui-icons design-2_ruler-pencil" /> Comentarios{"  "}
            <Button
              icon
              round
              key={"createCommentButton"}
              color="info"
              onClick={() => {
                // this.showPopUp(NOTA);
              }}
              leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
            />
          </h5>
        </CardHeader>
      </Card>
    );

    let commentsCard = null;
    let commentsCardBody = null;
    if (homeVisit.visit_comments && homeVisit.visit_comments.length > 0) {
      let visitComments = homeVisit.visit_comments;
      if (!visitComments) visitComments = [];
      if (visitComments.length > 0) {
        visitComments = visitComments.map((comment, key) => {
          let badgeStyle = 
          {
            color: "default",
            icon: "travel_info"
          };
          // if (comment.tipo === "Incidencia") {
          //   badgeStyle.color = "danger";
          //   badgeStyle.icon = "ui-2_settings-90";
          // }
          // if (comment.tipo === "Solución") {
          //   badgeStyle.color = "primary";
          //   badgeStyle.icon = "ui-2_like";
          // }
          // if (comment.tipo === "Log") {
          //   badgeStyle.color = "warning";
          //   badgeStyle.icon = "ui-1_bell-53";
          // }
          // if (comment.tipo === "Pago") {
          //   badgeStyle.color = "primary";
          //   badgeStyle.icon = "business_money-coins";
          // }

          return {
            inverted: true,
            badgeColor: badgeStyle.color,
            badgeUserPicture: comment.author.picture || "no-tiene",
            title: comment.author.username,
            titleColor: "primary",
            body: <div dangerouslySetInnerHTML={{ __html: comment.text }} />,
            footerTitle: comment.date,
            footerIcon: "now-ui-icons ui-1_calendar-60"
          };
        });
        commentsCardBody =
          <CardBody>
            <Timeline stories={visitComments} simple />
          </CardBody>;
      } else {
        commentsCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons ui-1_simple-remove" /> No hay comentarios...
            </div>
          </CardBody>;
      }
    } else {
      commentsCardBody = 
        <CardBody>
          <div>
            <i className="now-ui-icons ui-1_simple-remove" /> No hay comentarios...
          </div>
        </CardBody>;
    }
    commentsCard = (
      <Card key="notesCard" className="card-plain card-timeline">
        {commentsCardHeader}
        {commentsCardBody}
      </Card>
    );

    result = commentsCard;

    return result;
  }
  parseVisitType(type, name) {
    let result = null;
    let resultText = "";
    let resultStyle = "";
    type = parseInt(type);
    switch (type) {
      case 243:
        resultText = "Instalación WiFi";
        resultStyle = "btn-primary";
        break;
      case 244:
        resultText = "Incidencia";
        resultStyle = "btn-danger";
        break;
      case 245:
        resultText = "Configuración";
        resultStyle = "btn-info";
        break;
      case 246:
        resultText = "Servicio extra";
        resultStyle = "btn-info";
        break;
      case 256:
        resultText = "Instalación fibra";
        resultStyle = "btn-warning";
        break;
      default:
        resultText = "Error en el tipo";
        resultStyle = "btn-default";
        break;
    }
    resultStyle += " btn-sm btn-round btn";

    result = <span className={resultStyle}>{name}</span>;

    return result;
  }
  buildHomeVisitHeaderStatus() {
    let style = {
      padding: "5px 10px",
      borderRadius: "2px",
      margin: "0px 10px 0px 5px"
    };
    let durationStyle = {
      padding: "5px 10px",
      borderRadius: "2px",
      margin: "0px 10px 0px 5px",
      background: "rgba(255,255,255,0.1)",
      color: "#FFF"
    };
    let visit_state = null;
    let isFinished = false;
    let finishedThings = null;
    if (this.state.homeVisit && this.state.homeVisit.visit_state) {
      switch (this.state.homeVisit.visit_state.tid) {
        // Cancelada
        case 250:
          visit_state = {
            text: this.state.homeVisit.visit_state_name,
            color: "danger",
            icon: "ui-1_simple-remove"
          };
          break;
          // Esperando
        case 247:
          visit_state = {
            text: this.state.homeVisit.visit_state_name,
            color: "info",
            icon: "ui-2_time-alarm"
          };
          break;
          // En proceso
        case 248:
          visit_state = {
            text: this.state.homeVisit.visit_state_name,
            color: "warning",
            icon: "loader_gear spin"
          };
          if (!this.state.homeVisit.start_hour) {
            visit_state.duration = "Error en la duración";
          } else {
            let start = moment(this.state.homeVisit.start_hour, "DD/MM/YYYY HH:mm:ss");
            let end = moment();
            let durationd = end.diff(start, "days");
            let durationh = end.diff(start, "hours") - durationd*24;
            let durationm = end.diff(start, "minutes") - durationh*60 - durationd*24*60;
            let durations = end.diff(start, "seconds") - durationm*60 - durationh*3600 - durationd*24*60*60;
            durationd = durationd === 0? "" : durationd + (durationd > 1 ? " días " : " día ");
            durationh = durationh === 0? "" : durationh + (durationh > 1 ? " horas " : " hora ");
            durationm = durationm === 0? "" : durationm + (durationm > 1 ? " mins " : " min ");
            durations = durations === 0? "" : durations + (durations > 1 ? " segs " : " seg ");
            durations = "";
            let duration = (durationd + durationh + durationm + durations);
            // console.log("######## DURATION ############");
            // console.log(durationh + durationm + durations);

            visit_state.duration = (
              <span style={durationStyle}>
                <i className={"now-ui-icons ui-2_time-alarm"} />
                {" "}{duration}
              </span>
            );
          }
          break;
          // Finalizada
        case 249:
          isFinished = true;
          visit_state = {
            text: this.state.homeVisit.visit_state_name,
            color: "primary",
            icon: "ui-1_check"
          };
          if (this.state.homeVisit.finish_reason_name && this.state.homeVisit.finish_reason && this.state.homeVisit.finish_reason.tid) {
            let value = parseInt(this.state.homeVisit.finish_reason.tid);
            let label = this.state.homeVisit.finish_reason_name;
            let reasonStyle = this.getReasonStyle(value);
            let iconStyle = {
              padding: "5px 10px",
              marginRight: "10px",
              background: "rgba(0,0,0,0.1)",
              borderRadius: "15px",
              marginLeft: "-10px"
            }
            visit_state = {
              text: label,
              color: "",
              icon: reasonStyle.icon
            };
            style.background = reasonStyle.style.background;
            let finishReason = null;
            if (this.state.homeVisit.finish_reason.tid !== 257) {
              let finishReasonStyle = {
                padding: "5px 10px",
                background: "rgba(255,255,255,0.1)",
                borderRadius: "3px",
                marginLeft: "5px",
                color: "#FFF"
              };
              finishReason = (
                <Row className="text-center">
                  <Col xs={10} className="text-center ml-auto mr-auto">
                    <div>
                      <span style={{ marginBottom: "5px" }} className="category text-center">Explicación del técnico</span><br /><br />
                      <div className="home-visit-finish-reason">{this.state.homeVisit.finish_reason_description? 
                        <div className="" dangerouslySetInnerHTML={{__html: this.state.homeVisit.finish_reason_description}} /> : "..."}</div>
                    </div>
                  </Col>
                </Row>
              );
            }
            let currentEmoji = {};
            Object.keys(emojis).map((currentHappiness) => {
              let emoji = emojis[currentHappiness];
              if (parseInt(emoji.value) === parseInt(this.state.homeVisit.customer_happiness.tid))
                currentEmoji = emoji;
            });
            let customerCommentStyle = {
              padding: "5px 10px",
              background: "rgba(255,255,255,0.1)",
              borderRadius: "3px",
              marginLeft: "5px",
              color: "#FFF"
            };
            let emojiStyle = {
              fontSize: "25px"
            };
            let headerFooter = (
              <div>
                <div>
                  <br />
                  {finishReason}
                </div><br />
                <div>
                  <span style={{ marginBottom: "5px" }} className="category text-left">Satisfacción del cliente</span><br /><br />
                  <span style={emojiStyle}>{currentEmoji.icon}{" "}</span>
                  <span style={customerCommentStyle}>{this.state.homeVisit.customer_comment? 
                        <div style={{display: "inline-block"}} className="" dangerouslySetInnerHTML={{__html: this.state.homeVisit.customer_comment}} /> : "..."}</span>
                </div>
              </div>
            );
            finishedThings = headerFooter;

            // return {
            //   value: value,
            //   label: (
            //     <div style={{ display: "block" }}>
            //       <span style={reasonStyle.style}>
            //         <span style={iconStyle}><i className={"now-ui-icons " + reasonStyle.icon} /></span>
            //         {label}
            //       </span>
            //     </div>)
            // }
          }
          if (!this.state.homeVisit.start_hour) {
            visit_state.duration = "Error en la duración";
          } else {
            let start = moment(this.state.homeVisit.start_hour, "DD/MM/YYYY HH:mm:ss");
            let end = moment(this.state.homeVisit.end_hour, "DD/MM/YYYY HH:mm:ss");
            let durationd = end.diff(start, "days");
            let durationh = end.diff(start, "hours") - durationd*24;
            let durationm = end.diff(start, "minutes") - durationh*60 - durationd*24*60;
            let durations = end.diff(start, "seconds") - durationm*60 - durationh*3600 - durationd*24*60*60;
            durationd = durationd === 0? "" : durationd + (durationd > 1 ? " días " : " día ");
            durationh = durationh === 0? "" : durationh + (durationh > 1 ? " horas " : " hora ");
            durationm = durationm === 0? "" : durationm + (durationm > 1 ? " mins " : " min ");
            durations = durations === 0? "" : durations + (durations > 1 ? " segs" : " seg");
            let duration = (durationd + durationh + durationm + durations);
            // console.log("######## DURATION ############");
            // console.log(durationh + durationm + durations);

            visit_state.duration = (
              <span style={durationStyle}>
                <i className={"now-ui-icons ui-2_time-alarm"} />
                {" "}{duration}
              </span>
            );
          }
          break;
        default:
          visit_state = {
            text: "No se pudo cargar el estado",
            color: "default",
            icon: "ui-1_simple-remove"
          };
          break;
      }
      return (
        <div>
          <br />
          <span style={style} className={"bg-" + visit_state.color}>
            <i className={"now-ui-icons " + visit_state.icon} />
            {" "}{visit_state.text}
          </span>
          {visit_state.duration}
          {isFinished && finishedThings}
        </div>
      );
    }
    return null;
  }
  buildFinishing() {
    let finishing = (
      <Card key="finishingCard" className="text-center" color="primary">
        <CardHeader></CardHeader>
        <CardBody className="text-center">
          <h5 style={{ paddingTop: "25px"}}><i className="now-ui-icons arrows-1_refresh-69 spin" /> Firmando</h5>
        </CardBody>
        <CardFooter></CardFooter>
      </Card>
    );
    return (
      <Row>
        <Col xs={12}>
          {finishing}
        </Col>
      </Row>);
  }
  buildFinished() {
    let isErrorMessage = this.state.finishText.includes("Error");
    let messageIcon = isErrorMessage ? "ui-1_simple-remove" : "ui-1_check";
    let finishing = (
      <Card key="finishingCard" className="text-center" color={isErrorMessage ? "danger" : "primary"}>
        <CardHeader></CardHeader>
        <CardBody className="text-center">
          <h5 style={{ paddingTop: "25px"}}><i className={"now-ui-icons " + messageIcon} /> {this.state.finishText}</h5>
        </CardBody>
        <CardFooter></CardFooter>
      </Card>
    );
    return (
      <Row>
        <Col xs={12}>
          {finishing}
        </Col>
      </Row>);
  }
  buildMainContent() {
    let reminder = this.state.reminder;
    return (
      <Row>
        <Col xs={12}>
          <Card style={{ margin: 0 }}>
              <CardHeader><h4 className="h-nomargin">Descripción</h4></CardHeader>
              {/* <CardHeader><h5 className="h-nomargin">Descripción</h5></CardHeader> */}
              <CardBody className="text-left">
                <div>
                    <div className="" dangerouslySetInnerHTML={{__html: reminder.description}} />
                </div>
              </CardBody>
              {/* <CardFooter></CardFooter> */}
          </Card>
        </Col>
        {/* {comments && <Col xs={12} md={6}>
          {comments}
        </Col>} */}
      </Row>);
  }
  buildRightColumn() {
    let reminder = this.state.reminder;
    let shared = reminder.shared;
    if (shared && shared.length > 0) {
      let _shared = [];
      shared.forEach(element => {
        _shared.push(
          <div className="shared-each-wrapper">
            <div key={"shared-" + element.id} className="reminder-related-people">{element.name}</div>
          </div>
        )
      });
      shared = _shared;
    } else {
      shared = "Todavía no ha sido compartido"
    }
    return (
      <Row>
        <Col xs={12}>
          <Card>
              <CardHeader><h4 className="h-nomargin"><i className={"now-ui-icons business_badge"} /> Responsable</h4></CardHeader>
              {/* <CardHeader><h5 className="h-nomargin">Descripción</h5></CardHeader> */}
              <CardBody className="text-left">
                <div>
                  <div className="reminder-related-people">{reminder.author}</div>
                    {/* <div className="reminder-related-people" dangerouslySetInnerHTML={{__html: reminder.author}} /> */}
                </div>
              </CardBody>
              {/* <CardFooter></CardFooter> */}
          </Card>
        </Col>
        <Col xs={12}>
          <Card>
              <CardHeader><h4 className="h-nomargin"><i className={"now-ui-icons arrows-1_share-66"} /> Compartido con</h4></CardHeader>
              {/* <CardHeader><h5 className="h-nomargin">Descripción</h5></CardHeader> */}
              <CardBody className="text-left">
                <div>
                    {shared}
                </div>
              </CardBody>
              {/* <CardFooter></CardFooter> */}
          </Card>
        </Col>
        {/* {comments && <Col xs={12} md={6}>
          {comments}
        </Col>} */}
      </Row>);
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  buildBillingHeader(homeVisit) {
    console.log("Current home visit billing");
    console.log(homeVisit);
    let result = null;
    if(this.props.isBillingDepartment()) {
      let billingStatus = 0;
      try {
        billingStatus = parseInt(homeVisit.billing_status.tid);
      } catch (error) {
        billingStatus = 374;
      }
      let buttonText = "";
      let buttonColor = "";
      let buttonIcon = "";
      switch (billingStatus) {
        case 374: // Sin revisar
          buttonText = "Sin revisar";
          buttonColor = "danger";
          buttonIcon = "ui-2_time-alarm";
          break;   
        case 375: // Finalizada
          buttonText = "Revisada para facturación";
          buttonColor = "primary";
          buttonIcon = "business_money-coins";
          break;
        case 377: // Revisando
          buttonText = "En proceso de revisión";
          buttonColor = "warning";
          buttonIcon = "arrows-1_refresh-69 spin";
          break;      
        default:
          buttonText = "Sin revisar";
          buttonColor = "danger";
          buttonIcon = "ui-2_time-alarm";
          break;
      }
      if (this.props.mainState.isChangingHomeVisitBillingStatus) {
        buttonIcon = "arrows-1_refresh-69 spin";
      }
      result = (
        <Row>
          <Col xs={12} className="text-center">
            <Button
              color={buttonColor}
              size="lg"
              block
              onClick={() => this.changeBillingStatus(homeVisit)}
              disabled={this.props.mainState.isChangingHomeVisitBillingStatus}
            >
              <i className={"now-ui-icons " + buttonIcon} /> {buttonText}
            </Button>
          </Col>
        </Row>
      );
    }
    return result;
  }
  changeBillingStatus(homeVisit) {
    this.props.userData.changeHomeVisitBillingStatus(homeVisit.id);
  }
  render() {
    if (this.state.reminder) {
      let reminder = this.state.reminder;
      
      let mainContent = this.buildMainContent();
      let rightColumn = this.buildRightColumn();
      // let footer = this.buildFooter();
      // let billingHeader = this.buildBillingHeader(homeVisit);
      // let existingCustomer = null;
      // if (!this.props.userData.isTechnician()) {
        // existingCustomer = this.buildExistingCustomer();
      // let relatedContract = this.buildRelatedContract();
      // }
      // if (!this.state.isSigningContract) {
      //     return (
      //     <div>
      //         <PanelHeader size="sm" />
      //         <div className="content text-center">
      //           {existingCustomer}
      //         {contentToDisplay}
      //         {footer}
      //         </div>
      //     </div>
      //     );
      // } else {
      // let showLoadingLogMessage = this.props.mainState.isSearchingHomeVisitsLog || !this.props.mainState.log || 
      // !this.props.mainState.log.homeVisits || !(this.props.match.params.homeVisit in this.props.mainState.log.homeVisits);
      // let log = (
      //   <Col xs={12}>          
      //     {showLoadingLogMessage && <Row>
      //       <Col xs={12} className="text-center txt-white">
      //         <Card color="default">
      //           <CardBody>
      //             <div>
      //               <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando log de la cita
      //             </div>
      //           </CardBody>
      //         </Card>
      //       </Col>
      //     </Row>}
      //     {!showLoadingLogMessage && this.props.mainState.log.homeVisits[this.props.match.params.homeVisit].length > 0 && <Row>
      //       <Col xs={12} className="text-left">
      //         <Card className="card-plain log-calendario">
      //           <CardBody>
      //             <div className="text-center">
      //               <i className="now-ui-icons education_agenda-bookmark" /> Log de la cita
      //             </div>
      //             <table width="100%" style={{}}>
      //               <tbody>
      //                   {this.props.mainState.log.homeVisits[this.props.match.params.homeVisit].map(log => {
      //                     let date_class = "log-date ";
      //                     let log_date = <span className={date_class}>{moment(log.date).format('D/MM/YYYY - HH:mm:ss')}</span>;
      //                     let log_content = (
      //                       <div>
      //                         {log_date}
      //                         <div dangerouslySetInnerHTML={{ __html: log.text }} />
      //                       </div>
      //                     );
      //                     // Enlace solo necesario en la vista de calendario
      //                     // if (log.hasRedirect) {
      //                     //   log_content = (
      //                     //     <Link to={"/citas/" + log.redirect.id}>
      //                     //       {log_content}
      //                     //     </Link>
      //                     //   );
      //                     // }
      //                     log_content = (
      //                       <tr key={log.id}>
      //                         <td className="text-left">
      //                           {log_content}
      //                         </td>
      //                       </tr>
      //                     );
      //                     return log_content;
      //                   })}
      //               </tbody>
      //             </table>
      //           </CardBody>
      //         </Card>
      //       </Col>
      //       </Row>}
      //   </Col>
      // );
      let typeStyle = localityStyle;
      typeStyle.background = reminder.type_color;
      typeStyle.color = "#FFF";
      return (
        <div className="header-home-visit">
          <PanelHeader 
            content={
              <div className="header text-center">
                <div style={{ background: reminder.bgColor }} id="reminder-header-category">{reminder.category_name}</div>
                {/* <span className="category">{this.parseVisitType(homeVisit.visit_type ? homeVisit.visit_type.tid : "", homeVisit.visit_type_name)}</span><br /> */}
                <div className="category">
                  <Stats>
                    {[{ i: "now-ui-icons ui-1_calendar-60", t: reminder.date_day }]}
                  </Stats>
                </div>
                <h2 className="title h-small-margin">{reminder.date_hour}</h2>
                <div className="category">
                  {/* <a target='_blank' href={"https://www.google.es/maps/place/" + homeVisit.latitude + "," + homeVisit.longitude}> */}
                  <span key="span-out"><span key="span-in" style={typeStyle}>{reminder.type_name}</span>{reminder.title}</span>
                    {/* <Stats>
                      {[{ i: "now-ui-icons location_pin", t: <span key="span-out"><span key="span-in" style={localityStyle}>{homeVisit.visit_locality}</span>{homeVisit.visit_address}</span>}]}
                    </Stats> */}
                  {/* </a> */}
                </div>
                {/* {this.buildHomeVisitHeaderStatus()} */}
              </div>
            }
          />
            <div className="content text-left">
              <Row>
                <Col xs={12} md={8}>
                  {mainContent}
                </Col>
                <Col xs={12} md={4}>
                  {rightColumn}
                </Col>
              </Row>
              {/* {billingHeader} */}
              {/* {existingCustomer} */}
              {/* {relatedContract} */}
              {/* {log} */}
              {/* {content}
              {footer} */}
            </div>
        </div>
        );
        // }
    } else {
        return (
            <div>
                <PanelHeader size="sm" />
                <div className="content text-center">
                <Card color="primary" style={{ margin: 0 }}>
                    <CardHeader></CardHeader>
                    <CardBody className="text-center">
                      <div>
                          <div className="text-center">
                          <br />
                          <h5><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando</h5>
                          </div>
                      </div>
                    </CardBody>
                    <CardFooter></CardFooter>
                </Card>
                </div>
            </div>
        );
    }
  }
}

function generateRandomID() {
  return parseInt(Math.random() * (999999 - 100000) + 100000);
}

export default ViewReminder;



// WEBPACK FOOTER //
// ./src/views/Reminders/ViewReminder.jsx